webpackJsonp([40,0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(1049);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(18);
	
	new _vue2.default({
	  el: '#app',
	  template: '<register />',
	  components: { Register: _App2.default },
	  beforeCreate: function beforeCreate() {
	    this.doAfterSyncLogin(this, null, true, 3);
	  }
	});

/***/ }),

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var merge = __webpack_require__(190);
	
	
	var config = {
	  "STORAGE_TOKEN_NAME": "stoken",
	  "STORAGE_USER": "suser",
	  "COOKIE_TOKEN_NAME": "ctoken",
	  "COOKIE_LOGIN_TOKEN": "ltoken",
	  defaultLoginType: 1 };
	
	if (true) {
	  config = merge(config, {
	    domain: {
	      "forensicsBackstage": "https://bs.ebaoquan.org",
	      "forensicsWebOp": "https://i.ebaoquan.org",
	      "athenaBackstage": "https://bs.wbq360.com",
	      "athenaWebUms": "https://i.wbq360.com",
	      "accountWeb": "https://account.ebaoquan.org",
	      "athenaFront": "https://www.wbq360.com",
	      "portal": "https://www.ebaoquan.org",
	      "junziqianWebOp": "https://web.junziqian.com",
	      "jzqBackstage": "https://s.junziqian.com",
	      "rtcDomain": "https://rtc.ebaoquan.com"
	    }
	  });
	} else if (process.env.NODE_ENV === 'sandbox') {
	  config = merge(config, {
	    domain: {
	      "forensicsBackstage": "http://bs.sandbox.ebaoquan.org",
	      "forensicsWebOp": "http://i.sandbox.ebaoquan.org",
	      "athenaBackstage": "http://bs.sandbox.wbq360.com",
	      "athenaWebUms": "http://i.sandbox.wbq360.com",
	      "accountWeb": "https://account-sandbox.ebaoquan.org",
	      "athenaFront": "http://sandbox.wbq360.com",
	      "portal": "http://sandbox.ebaoquan.org",
	      "junziqianWebOp": "http://web.sandbox.junziqian.com",
	      "jzqBackstage": "http://s.sandbox.junziqian.com",
	      "rtcDomain": "https://rtc-sandbox.ebaoquan.com"
	    }
	  });
	  console.log(config);
	} else {
	  config = merge(config, {
	    domain: {
	      "forensicsBackstage": "http://bs.sandbox.ebaoquan.org",
	      "forensicsWebOp": "http://i.ebaoquan.test:81",
	      "athenaBackstage": "http://bs.sandbox.wbq360.com",
	      "athenaWebUms": "http://i.sandbox.wbq360.com",
	      "accountWeb": "https://account-sandbox.ebaoquan.org",
	
	      "athenaFront": "http://sandbox.wbq360.com",
	      "portal": "http://sandbox.ebaoquan.org",
	      "junziqianWebOp": "http://web.sandbox.junziqian.com",
	      "jzqBackstage": "http://s.sandbox.junziqian.com",
	      "rtcDomain": "https://rtc-sandbox.ebaoquan.com"
	    }
	  });
	}
	module.exports = config;
	_vue2.default.prototype.globalConfig = config;

/***/ }),

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(15);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _es6Promise = __webpack_require__(160);
	
	var _es6Promise2 = _interopRequireDefault(_es6Promise);
	
	var _axios = __webpack_require__(13);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _vueAxios = __webpack_require__(14);
	
	var _vueAxios2 = _interopRequireDefault(_vueAxios);
	
	var _vueCookie = __webpack_require__(10);
	
	var _vueCookie2 = _interopRequireDefault(_vueCookie);
	
	var _GlobalConfig = __webpack_require__(2);
	
	var _GlobalConfig2 = _interopRequireDefault(_GlobalConfig);
	
	var _layer = __webpack_require__(5);
	
	var _layer2 = _interopRequireDefault(_layer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(160).polyfill();
	_vue2.default.use(_vueAxios2.default, _axios2.default);
	
	_vue2.default.axios.defaults.withCredentials = true;
	
	_vue2.default.axios.interceptors.request.use(function (config) {
	  if (localStorage.getItem(_GlobalConfig2.default.STORAGE_TOKEN_NAME)) {
	    config.headers.Authorization = 'Bearer ' + localStorage.getItem(_GlobalConfig2.default.STORAGE_TOKEN_NAME);
	  }
	  return config;
	}, function (err) {
	  return _es6Promise2.default.reject(err);
	});
	
	_vue2.default.axios.interceptors.response.use(function (response) {
	  var cookieToken = _vueCookie2.default.get(_GlobalConfig2.default.COOKIE_TOKEN_NAME);
	  if (cookieToken) {
	    var stoken = localStorage.getItem(_GlobalConfig2.default.STORAGE_TOKEN_NAME);
	    if (cookieToken != stoken) {
	      localStorage.setItem(_GlobalConfig2.default.STORAGE_TOKEN_NAME, cookieToken);
	    }
	    _vueCookie2.default.delete(_GlobalConfig2.default.COOKIE_TOKEN_NAME);
	  }
	  return response;
	}, function (err) {
	  return _es6Promise2.default.reject(err);
	});
	
	exports.default = {
	  ie9: function ie9() {
	    return navigator.appName == "Microsoft Internet Explorer" && navigator.appVersion.match(/9./i) == "9.";
	  },
	  get: function get(url, callback, config) {
	    var _this = this;
	
	    if (this.ie9()) {
	      return;
	    } else {
	      _vue2.default.axios.get(url, config).then(function (response) {
	        if (response.data.code == 1) {
	          console.log("need put doAfterSyncLogin => " + url);
	        }
	        _this.dealResult(response, callback);
	      }).catch(function (error) {
	        console.log(error);
	      });
	    }
	  },
	  getBlob: function getBlob(url, callback) {
	    var _this2 = this;
	
	    if (this.ie9()) {
	      return;
	    } else {
	      _vue2.default.axios.get(url, { responseType: 'blob' }).then(function (response) {
	        if (response.data.code == 1) {
	          console.log("need put doAfterSyncLogin => " + url);
	        }
	        _this2.dealResult(response, callback);
	      }).catch(function (error) {
	        console.log(error);
	      });
	    }
	  },
	  doPost: function doPost(url, data, callback) {
	    var _this3 = this;
	
	    return (0, _axios2.default)({
	      method: 'post',
	      url: url,
	      data: (0, _stringify2.default)(data),
	      timeout: 30000,
	      headers: {
	        'X-Requested-With': 'XMLHttpRequest',
	        'Content-Type': 'application/json; charset=UTF-8',
	        "Authorization": 'Bearer ' + localStorage.getItem(_GlobalConfig2.default.STORAGE_TOKEN_NAME)
	      }
	    }).then(function (response) {
	      if (response.data.code == 1) {
	        console.log("need put doAfterSyncLogin => " + url);
	      }
	      _this3.dealResult(response, callback);
	    }).catch(function (error) {
	      console.log(error);
	    });
	  },
	  post: function post(url, data, callback) {
	    var _this4 = this;
	
	    if (this.ie9()) {
	      return;
	    } else {
	      var qs = __webpack_require__(195);
	      _vue2.default.axios.post(url, qs.stringify(data), {
	        headers: {
	          'Content-Type': 'application/x-www-form-urlencoded',
	          "Authorization": 'Bearer ' + localStorage.getItem(_GlobalConfig2.default.STORAGE_TOKEN_NAME)
	        }
	      }).then(function (response) {
	        if (response.data.code == 1) {
	          console.log("need put doAfterSyncLogin => " + url);
	        }
	        _this4.dealResult(response, callback);
	      }).catch(function (error) {
	        console.log(error);
	      });
	    }
	  },
	  postMulti: function postMulti(url, form, callback, uploadProgressHandler) {
	    var _this5 = this;
	
	    var options = { method: 'post', headers: { 'Content-Type': 'multipart/form-data' } };
	    if (uploadProgressHandler) {
	      options.onUploadProgress = uploadProgressHandler;
	    }
	    _vue2.default.axios.post(url, form, options).then(function (response) {
	      _this5.dealResult(response, callback);
	    }).catch(function (error) {
	      console.log(error);
	    });
	  },
	  dealResult: function dealResult(response, callback) {
	    if (response.data.code == 1) {
	      if (_GlobalConfig2.default.defaultLoginType == 1) {
	        window.location.href = _GlobalConfig2.default.domain.forensicsWebOp + "/login.html?returnURL=" + encodeURIComponent(location.href);
	      } else if (_GlobalConfig2.default.defaultLoginType == 2) {
	        _layer2.default.open({
	          type: 2,
	          title: false,
	          icon: 2,
	          closeBtn: 0,
	          area: ['400px', '480px'],
	          fixed: false,
	          content: [_GlobalConfig2.default.domain.accountWeb + '/plogin/loginPage?corsUrl=' + encodeURIComponent(_GlobalConfig2.default.domain.athenaWebUms + "/login-cors.html"), 'no'],
	          success: function success() {
	            $(".layui-layer-iframe,.layui-layer-content").css("border-radius", "10px");
	          }
	        });
	      }
	    } else {
	      callback(response);
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(jQuery) {"use strict";
	
	var _typeof2 = __webpack_require__(3);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;!function (a, b) {
	  "use strict";
	  var c,
	      d,
	      e = { getPath: function () {
	      var a = document.scripts,
	          b = a[a.length - 1],
	          c = b.src;if (!b.getAttribute("merge")) return c.substring(0, c.lastIndexOf("/") + 1);
	    }(), enter: function enter(a) {
	      13 === a.keyCode && a.preventDefault();
	    }, config: {}, end: {}, btn: ["&#x786E;&#x5B9A;", "&#x53D6;&#x6D88;"], type: ["dialog", "page", "iframe", "loading", "tips"] },
	      f = { v: "2.0", ie6: !!a.ActiveXObject && !a.XMLHttpRequest, index: 0, path: e.getPath, config: function config(a, b) {
	      var d = 0;return a = a || {}, f.cache = e.config = c.extend(e.config, a), f.path = e.config.path || f.path, "string" == typeof a.extend && (a.extend = [a.extend]), f.use("skin/layer.css", a.extend && a.extend.length > 0 ? function g() {
	        var c = a.extend;f.use(c[c[d] ? d : d - 1], d < c.length ? function () {
	          return ++d, g;
	        }() : b);
	      }() : b), this;
	    }, use: function use(a, b, d) {
	      var e = c("head")[0],
	          a = a.replace(/\s/g, ""),
	          g = /\.css$/.test(a),
	          h = document.createElement(g ? "link" : "script"),
	          i = "layui_layer_" + a.replace(/\.|\//g, "");return f.path ? (g && (h.rel = "stylesheet"), h[g ? "href" : "src"] = /^http:\/\//.test(a) ? a : f.path + a, h.id = i, c("#" + i)[0] || e.appendChild(h), function j() {
	        (g ? 1989 === parseInt(c("#" + i).css("width")) : f[d || i]) ? function () {
	          b && b();try {
	            g || e.removeChild(h);
	          } catch (a) {}
	        }() : setTimeout(j, 100);
	      }(), this) : void 0;
	    }, ready: function ready(a, b) {
	      var d = "function" == typeof a;return d && (b = a), f.config(c.extend(e.config, function () {
	        return d ? {} : { path: a };
	      }()), b), this;
	    }, alert: function alert(a, b, d) {
	      var e = "function" == typeof b;return e && (d = b), f.open(c.extend({ content: a, yes: d }, e ? {} : b));
	    }, confirm: function confirm(a, b, d, g) {
	      var h = "function" == typeof b;return h && (g = d, d = b), f.open(c.extend({ content: a, btn: e.btn, yes: d, cancel: g }, h ? {} : b));
	    }, msg: function msg(a, d, g) {
	      var i = "function" == typeof d,
	          j = e.config.skin,
	          k = (j ? j + " " + j + "-msg" : "") || "layui-layer-msg",
	          l = h.anim.length - 1;return i && (g = d), f.open(c.extend({ content: a, time: 3e3, shade: !1, skin: k, title: !1, closeBtn: !1, btn: !1, end: g }, i && !e.config.skin ? { skin: k + " layui-layer-hui", shift: l } : function () {
	        return d = d || {}, (-1 === d.icon || d.icon === b && !e.config.skin) && (d.skin = k + " " + (d.skin || "layui-layer-hui")), d;
	      }()));
	    }, load: function load(a, b) {
	      return f.open(c.extend({ type: 3, icon: a || 0, shade: .01 }, b));
	    }, tips: function tips(a, b, d) {
	      return f.open(c.extend({ type: 4, content: [a, b], closeBtn: !1, time: 3e3, maxWidth: 210 }, d));
	    } },
	      g = function g(a) {
	    var b = this;b.index = ++f.index, b.config = c.extend({}, b.config, e.config, a), b.creat();
	  };g.pt = g.prototype;var h = ["layui-layer", ".layui-layer-title", ".layui-layer-main", ".layui-layer-dialog", "layui-layer-iframe", "layui-layer-content", "layui-layer-btn", "layui-layer-close"];h.anim = ["layui-anim", "layui-anim-01", "layui-anim-02", "layui-anim-03", "layui-anim-04", "layui-anim-05", "layui-anim-06"], g.pt.config = { type: 0, shade: .3, fix: !0, move: h[1], title: "&#x4FE1;&#x606F;", offset: "auto", area: "auto", closeBtn: 1, time: 0, zIndex: 19891014, maxWidth: 360, shift: 0, icon: -1, scrollbar: !0, tips: 2 }, g.pt.vessel = function (a, b) {
	    var c = this,
	        d = c.index,
	        f = c.config,
	        g = f.zIndex + d,
	        i = "object" == (0, _typeof3.default)(f.title),
	        j = f.maxmin && (1 === f.type || 2 === f.type),
	        k = f.title ? '<div class="layui-layer-title" style="' + (i ? f.title[1] : "") + '">' + (i ? f.title[0] : f.title) + "</div>" : "";return f.zIndex = g, b([f.shade ? '<div class="layui-layer-shade" id="layui-layer-shade' + d + '" times="' + d + '" style="' + ("z-index:" + (g - 1) + "; background-color:" + (f.shade[1] || "#000") + "; opacity:" + (f.shade[0] || f.shade) + "; filter:alpha(opacity=" + (100 * f.shade[0] || 100 * f.shade) + ");") + '"></div>' : "", '<div class="' + h[0] + " " + (h.anim[f.shift] || "") + (" layui-layer-" + e.type[f.type]) + (0 != f.type && 2 != f.type || f.shade ? "" : " layui-layer-border") + " " + (f.skin || "") + '" id="' + h[0] + d + '" type="' + e.type[f.type] + '" times="' + d + '" showtime="' + f.time + '" conType="' + (a ? "object" : "string") + '" style="z-index: ' + g + "; width:" + f.area[0] + ";height:" + f.area[1] + (f.fix ? "" : ";position:absolute;") + '">' + (a && 2 != f.type ? "" : k) + '<div class="layui-layer-content' + (0 == f.type && -1 !== f.icon ? " layui-layer-padding" : "") + (3 == f.type ? " layui-layer-loading" + f.icon : "") + '">' + (0 == f.type && -1 !== f.icon ? '<i class="layui-layer-ico layui-layer-ico' + f.icon + '"></i>' : "") + (1 == f.type && a ? "" : f.content || "") + '</div><span class="layui-layer-setwin">' + function () {
	      var a = j ? '<a class="layui-layer-min" href="javascript:;"><cite></cite></a><a class="layui-layer-ico layui-layer-max" href="javascript:;"></a>' : "";return f.closeBtn && (a += '<a class="layui-layer-ico ' + h[7] + " " + h[7] + (f.title ? f.closeBtn : 4 == f.type ? "1" : "2") + '" href="javascript:;"></a>'), a;
	    }() + "</span>" + (f.btn ? function () {
	      var a = "";"string" == typeof f.btn && (f.btn = [f.btn]);for (var b = 0, c = f.btn.length; c > b; b++) {
	        a += '<a class="' + h[6] + b + '">' + f.btn[b] + "</a>";
	      }return '<div class="' + h[6] + '">' + a + "</div>";
	    }() : "") + "</div>"], k), c;
	  }, g.pt.creat = function () {
	    var a = this,
	        b = a.config,
	        g = a.index,
	        i = b.content,
	        j = "object" == (typeof i === "undefined" ? "undefined" : (0, _typeof3.default)(i));switch ("string" == typeof b.area && (b.area = "auto" === b.area ? ["", ""] : [b.area, ""]), b.type) {case 0:
	        b.btn = "btn" in b ? b.btn : e.btn[0], f.closeAll("dialog");break;case 2:
	        var i = b.content = j ? b.content : [b.content || "http://sentsin.com?from=layer", "auto"];b.content = '<iframe scrolling="' + (b.content[1] || "auto") + '" allowtransparency="true" id="' + h[4] + g + '" name="' + h[4] + g + '" onload="this.className=\'\';" class="layui-layer-load" frameborder="0" src="' + b.content[0] + '"></iframe>';break;case 3:
	        b.title = !1, b.closeBtn = !1, -1 === b.icon && 0 === b.icon, f.closeAll("loading");break;case 4:
	        j || (b.content = [b.content, "body"]), b.follow = b.content[1], b.content = b.content[0] + '<i class="layui-layer-TipsG"></i>', b.title = !1, b.shade = !1, b.fix = !1, b.tips = "object" == (0, _typeof3.default)(b.tips) ? b.tips : [b.tips, !0], b.tipsMore || f.closeAll("tips");}a.vessel(j, function (d, e) {
	      c("body").append(d[0]), j ? function () {
	        2 == b.type || 4 == b.type ? function () {
	          c("body").append(d[1]);
	        }() : function () {
	          i.parents("." + h[0])[0] || (i.show().addClass("layui-layer-wrap").wrap(d[1]), c("#" + h[0] + g).find("." + h[5]).before(e));
	        }();
	      }() : c("body").append(d[1]), a.layero = c("#" + h[0] + g), b.scrollbar || h.html.css("overflow", "hidden").attr("layer-full", g);
	    }).auto(g), 2 == b.type && f.ie6 && a.layero.find("iframe").attr("src", i[0]), c(document).off("keydown", e.enter).on("keydown", e.enter), 4 == b.type ? a.tips() : a.offset(), b.fix && d.on("resize", function () {
	      a.offset(), (/^\d+%$/.test(b.area[0]) || /^\d+%$/.test(b.area[1])) && a.auto(g), 4 == b.type && a.tips();
	    }), b.time <= 0 || setTimeout(function () {
	      f.close(a.index);
	    }, b.time), a.move().callback();
	  }, g.pt.auto = function (a) {
	    function b(a) {
	      a = g.find(a), a.height(i[1] - j - k - 2 * (0 | parseFloat(a.css("padding"))));
	    }var e = this,
	        f = e.config,
	        g = c("#" + h[0] + a);"" === f.area[0] && f.maxWidth > 0 && (/MSIE 7/.test(navigator.userAgent) && f.btn && g.width(g.innerWidth()), g.outerWidth() > f.maxWidth && g.width(f.maxWidth));var i = [g.innerWidth(), g.innerHeight()],
	        j = g.find(h[1]).outerHeight() || 0,
	        k = g.find("." + h[6]).outerHeight() || 0;switch (f.type) {case 2:
	        b("iframe");break;default:
	        "" === f.area[1] ? f.fix && i[1] >= d.height() && (i[1] = d.height(), b("." + h[5])) : b("." + h[5]);}return e;
	  }, g.pt.offset = function () {
	    var a = this,
	        b = a.config,
	        c = a.layero,
	        e = [c.outerWidth(), c.outerHeight()],
	        f = "object" == (0, _typeof3.default)(b.offset);a.offsetTop = (d.height() - e[1]) / 2, a.offsetLeft = (d.width() - e[0]) / 2, f ? (a.offsetTop = b.offset[0], a.offsetLeft = b.offset[1] || a.offsetLeft) : "auto" !== b.offset && (a.offsetTop = b.offset, "rb" === b.offset && (a.offsetTop = d.height() - e[1], a.offsetLeft = d.width() - e[0])), b.fix || (a.offsetTop = /%$/.test(a.offsetTop) ? d.height() * parseFloat(a.offsetTop) / 100 : parseFloat(a.offsetTop), a.offsetLeft = /%$/.test(a.offsetLeft) ? d.width() * parseFloat(a.offsetLeft) / 100 : parseFloat(a.offsetLeft), a.offsetTop += d.scrollTop(), a.offsetLeft += d.scrollLeft()), c.css({ top: a.offsetTop, left: a.offsetLeft });
	  }, g.pt.tips = function () {
	    var a = this,
	        b = a.config,
	        e = a.layero,
	        f = [e.outerWidth(), e.outerHeight()],
	        g = c(b.follow);g[0] || (g = c("body"));var i = { width: g.outerWidth(), height: g.outerHeight(), top: g.offset().top, left: g.offset().left },
	        j = e.find(".layui-layer-TipsG"),
	        k = b.tips[0];b.tips[1] || j.remove(), i.autoLeft = function () {
	      i.left + f[0] - d.width() > 0 ? (i.tipLeft = i.left + i.width - f[0], j.css({ right: 12, left: "auto" })) : i.tipLeft = i.left;
	    }, i.where = [function () {
	      i.autoLeft(), i.tipTop = i.top - f[1] - 10, j.removeClass("layui-layer-TipsB").addClass("layui-layer-TipsT").css("border-right-color", b.tips[1]);
	    }, function () {
	      i.tipLeft = i.left + i.width + 10, i.tipTop = i.top, j.removeClass("layui-layer-TipsL").addClass("layui-layer-TipsR").css("border-bottom-color", b.tips[1]);
	    }, function () {
	      i.autoLeft(), i.tipTop = i.top + i.height + 10, j.removeClass("layui-layer-TipsT").addClass("layui-layer-TipsB").css("border-right-color", b.tips[1]);
	    }, function () {
	      i.tipLeft = i.left - f[0] - 10, i.tipTop = i.top, j.removeClass("layui-layer-TipsR").addClass("layui-layer-TipsL").css("border-bottom-color", b.tips[1]);
	    }], i.where[k - 1](), 1 === k ? i.top - (d.scrollTop() + f[1] + 16) < 0 && i.where[2]() : 2 === k ? d.width() - (i.left + i.width + f[0] + 16) > 0 || i.where[3]() : 3 === k ? i.top - d.scrollTop() + i.height + f[1] + 16 - d.height() > 0 && i.where[0]() : 4 === k && f[0] + 16 - i.left > 0 && i.where[1](), e.find("." + h[5]).css({ "background-color": b.tips[1], "padding-right": b.closeBtn ? "30px" : "" }), e.css({ left: i.tipLeft, top: i.tipTop });
	  }, g.pt.move = function () {
	    var a = this,
	        b = a.config,
	        e = { setY: 0, moveLayer: function moveLayer() {
	        var a = e.layero,
	            b = parseInt(a.css("margin-left")),
	            c = parseInt(e.move.css("left"));0 === b || (c -= b), "fixed" !== a.css("position") && (c -= a.parent().offset().left, e.setY = 0), a.css({ left: c, top: parseInt(e.move.css("top")) - e.setY });
	      } },
	        f = a.layero.find(b.move);return b.move && f.attr("move", "ok"), f.css({ cursor: b.move ? "move" : "auto" }), c(b.move).on("mousedown", function (a) {
	      if (a.preventDefault(), "ok" === c(this).attr("move")) {
	        e.ismove = !0, e.layero = c(this).parents("." + h[0]);var f = e.layero.offset().left,
	            g = e.layero.offset().top,
	            i = e.layero.outerWidth() - 6,
	            j = e.layero.outerHeight() - 6;c("#layui-layer-moves")[0] || c("body").append('<div id="layui-layer-moves" class="layui-layer-moves" style="left:' + f + "px; top:" + g + "px; width:" + i + "px; height:" + j + 'px; z-index:2147483584"></div>'), e.move = c("#layui-layer-moves"), b.moveType && e.move.css({ visibility: "hidden" }), e.moveX = a.pageX - e.move.position().left, e.moveY = a.pageY - e.move.position().top, "fixed" !== e.layero.css("position") || (e.setY = d.scrollTop());
	      }
	    }), c(document).mousemove(function (a) {
	      if (e.ismove) {
	        var c = a.pageX - e.moveX,
	            f = a.pageY - e.moveY;if (a.preventDefault(), !b.moveOut) {
	          e.setY = d.scrollTop();var g = d.width() - e.move.outerWidth(),
	              h = e.setY;0 > c && (c = 0), c > g && (c = g), h > f && (f = h), f > d.height() - e.move.outerHeight() + e.setY && (f = d.height() - e.move.outerHeight() + e.setY);
	        }e.move.css({ left: c, top: f }), b.moveType && e.moveLayer(), c = f = g = h = null;
	      }
	    }).mouseup(function () {
	      try {
	        e.ismove && (e.moveLayer(), e.move.remove(), b.moveEnd && b.moveEnd()), e.ismove = !1;
	      } catch (a) {
	        e.ismove = !1;
	      }
	    }), a;
	  }, g.pt.callback = function () {
	    function a() {
	      var a = g.cancel && g.cancel(b.index);a === !1 || f.close(b.index);
	    }var b = this,
	        d = b.layero,
	        g = b.config;b.openLayer(), g.success && (2 == g.type ? d.find("iframe")[0].onload = function () {
	      this.className = "", g.success(d, b.index);
	    } : g.success(d, b.index)), f.ie6 && b.IE6(d), d.find("." + h[6]).children("a").on("click", function () {
	      var e = c(this).index();0 === e ? g.yes ? g.yes(b.index, d) : f.close(b.index) : 1 === e && a(), g["btn" + (e + 1)] ? g["btn" + (e + 1)](b.index, d) : f.close(b.index);
	    }), d.find("." + h[7]).on("click", a), g.shadeClose && c("#layui-layer-shade" + b.index).on("click", function () {
	      f.close(b.index);
	    }), d.find(".layui-layer-min").on("click", function () {
	      f.min(b.index, g), g.min && g.min(d);
	    }), d.find(".layui-layer-max").on("click", function () {
	      c(this).hasClass("layui-layer-maxmin") ? (f.restore(b.index), g.restore && g.restore(d)) : (f.full(b.index, g), g.full && g.full(d));
	    }), g.end && (e.end[b.index] = g.end);
	  }, e.reselect = function () {
	    c.each(c("select"), function (a, b) {
	      var d = c(this);d.parents("." + h[0])[0] || 1 == d.attr("layer") && c("." + h[0]).length < 1 && d.removeAttr("layer").show(), d = null;
	    });
	  }, g.pt.IE6 = function (a) {
	    function b() {
	      a.css({ top: f + (e.config.fix ? d.scrollTop() : 0) });
	    }var e = this,
	        f = a.offset().top;b(), d.scroll(b), c("select").each(function (a, b) {
	      var d = c(this);d.parents("." + h[0])[0] || "none" === d.css("display") || d.attr({ layer: "1" }).hide(), d = null;
	    });
	  }, g.pt.openLayer = function () {
	    var a = this;f.zIndex = a.config.zIndex, f.setTop = function (a) {
	      var b = function b() {
	        f.zIndex++, a.css("z-index", f.zIndex + 1);
	      };return f.zIndex = parseInt(a[0].style.zIndex), a.on("mousedown", b), f.zIndex;
	    };
	  }, e.record = function (a) {
	    var b = [a.outerWidth(), a.outerHeight(), a.position().top, a.position().left + parseFloat(a.css("margin-left"))];a.find(".layui-layer-max").addClass("layui-layer-maxmin"), a.attr({ area: b });
	  }, e.rescollbar = function (a) {
	    h.html.attr("layer-full") == a && (h.html[0].style.removeProperty ? h.html[0].style.removeProperty("overflow") : h.html[0].style.removeAttribute("overflow"), h.html.removeAttr("layer-full"));
	  }, f.getChildFrame = function (a, b) {
	    return b = b || c("." + h[4]).attr("times"), c("#" + h[0] + b).find("iframe").contents().find(a);
	  }, f.getFrameIndex = function (a) {
	    return c("#" + a).parents("." + h[4]).attr("times");
	  }, f.iframeAuto = function (a) {
	    if (a) {
	      var b = f.getChildFrame("body", a).outerHeight(),
	          d = c("#" + h[0] + a),
	          e = d.find(h[1]).outerHeight() || 0,
	          g = d.find("." + h[6]).outerHeight() || 0;d.css({ height: b + e + g }), d.find("iframe").css({ height: b });
	    }
	  }, f.iframeSrc = function (a, b) {
	    c("#" + h[0] + a).find("iframe").attr("src", b);
	  }, f.style = function (a, b) {
	    var d = c("#" + h[0] + a),
	        f = d.attr("type"),
	        g = d.find(h[1]).outerHeight() || 0,
	        i = d.find("." + h[6]).outerHeight() || 0;(f === e.type[1] || f === e.type[2]) && (d.css(b), f === e.type[2] && d.find("iframe").css({ height: parseFloat(b.height) - g - i }));
	  }, f.min = function (a, b) {
	    var d = c("#" + h[0] + a),
	        g = d.find(h[1]).outerHeight() || 0;e.record(d), f.style(a, { width: 180, height: g, overflow: "hidden" }), d.find(".layui-layer-min").hide(), "page" === d.attr("type") && d.find(h[4]).hide(), e.rescollbar(a);
	  }, f.restore = function (a) {
	    var b = c("#" + h[0] + a),
	        d = b.attr("area").split(",");b.attr("type");f.style(a, { width: parseFloat(d[0]), height: parseFloat(d[1]), top: parseFloat(d[2]), left: parseFloat(d[3]), overflow: "visible" }), b.find(".layui-layer-max").removeClass("layui-layer-maxmin"), b.find(".layui-layer-min").show(), "page" === b.attr("type") && b.find(h[4]).show(), e.rescollbar(a);
	  }, f.full = function (a) {
	    var b,
	        g = c("#" + h[0] + a);e.record(g), h.html.attr("layer-full") || h.html.css("overflow", "hidden").attr("layer-full", a), clearTimeout(b), b = setTimeout(function () {
	      var b = "fixed" === g.css("position");f.style(a, { top: b ? 0 : d.scrollTop(), left: b ? 0 : d.scrollLeft(), width: d.width(), height: d.height() }), g.find(".layui-layer-min").hide();
	    }, 100);
	  }, f.title = function (a, b) {
	    var d = c("#" + h[0] + (b || f.index)).find(h[1]);d.html(a);
	  }, f.close = function (a) {
	    var b = c("#" + h[0] + a),
	        d = b.attr("type");if (b[0]) {
	      if (d === e.type[1] && "object" === b.attr("conType")) {
	        b.children(":not(." + h[5] + ")").remove();for (var g = 0; 2 > g; g++) {
	          b.find(".layui-layer-wrap").unwrap().hide();
	        }
	      } else {
	        if (d === e.type[2]) try {
	          var i = c("#" + h[4] + a)[0];i.contentWindow.document.write(""), i.contentWindow.close(), b.find("." + h[5])[0].removeChild(i);
	        } catch (j) {}b[0].innerHTML = "", b.remove();
	      }c("#layui-layer-moves, #layui-layer-shade" + a).remove(), f.ie6 && e.reselect(), e.rescollbar(a), c(document).off("keydown", e.enter), "function" == typeof e.end[a] && e.end[a](), delete e.end[a];
	    }
	  }, f.closeAll = function (a) {
	    c.each(c("." + h[0]), function () {
	      var b = c(this),
	          d = a ? b.attr("type") === a : 1;d && f.close(b.attr("times")), d = null;
	    });
	  }, e.run = function () {
	    c = jQuery, d = c(a), h.html = c("html"), f.open = function (a) {
	      var b = new g(a);return b.index;
	    };
	  },  true ? !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return e.run(), f;
	  }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : function () {
	    a.layer = f, e.run(), f.use("skin/layer.css");
	  }();
	}(window);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(3);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports.default = function (data) {
	  var url = data.url;
	  var method = data.method;
	  var successFun = data.success;
	  var withCredentials = data.withCredentials;
	  var dataBody = null;
	  if (typeof data.data === "string") {
	    dataBody = data.data;
	  } else if ((0, _typeof3.default)(data.data) == "object") {
	    var param = new Array();
	    for (var i in data.data) {
	      param.push(i + "=" + data.data[i]);
	    }
	    dataBody = param.join("&");
	  }
	
	  var xmlhttp = new XMLHttpRequest();
	  if ("withCredentials" in xmlhttp) {} else if (window.XDomainRequest) {
	    xmlhttp = new XDomainRequest();
	  } else {
	    console.log("你的浏览器不支持!");
	    return;
	  }
	  if (xmlhttp != null) {
	    xmlhttp.open(method, url);
	    if (withCredentials) {
	      xmlhttp.withCredentials = true;
	    }
	    if (localStorage.getItem(_GlobalConfig2.default.STORAGE_TOKEN_NAME) && xmlhttp.setRequestHeader) {
	      if (url.indexOf(_GlobalConfig2.default.domain.forensicsBackstage) > -1) {
	        xmlhttp.setRequestHeader("Authorization", 'Bearer ' + localStorage.getItem(_GlobalConfig2.default.STORAGE_TOKEN_NAME));
	      }
	    }
	    if (dataBody && dataBody != null && dataBody != "" && xmlhttp.setRequestHeader) {
	      xmlhttp.setRequestHeader("content-type", "application/x-www-form-urlencoded");
	    }
	    xmlhttp.send(dataBody);
	    xmlhttp.onload = function () {
	      var data = xmlhttp.responseText;
	      if (!data) {
	        data = xmlhttp.response;
	      }
	      if (typeof data === "string") {
	        data = eval("(" + data + ")");
	      }
	      if (successFun && typeof successFun == "function") {
	        var cookieToken = _vueCookie2.default.get(_GlobalConfig2.default.COOKIE_TOKEN_NAME);
	        if (cookieToken) {
	          localStorage.setItem(_GlobalConfig2.default.STORAGE_TOKEN_NAME, cookieToken);
	          _vueCookie2.default.delete(_GlobalConfig2.default.COOKIE_TOKEN_NAME);
	        }
	        successFun(data);
	      } else {
	        console.log(data);
	      }
	    };
	  } else {
	    alert("Your browser does not support XMLHTTP.");
	  }
	};
	
	var _GlobalConfig = __webpack_require__(2);
	
	var _GlobalConfig2 = _interopRequireDefault(_GlobalConfig);
	
	var _vueCookie = __webpack_require__(10);
	
	var _vueCookie2 = _interopRequireDefault(_vueCookie);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 17:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof2 = __webpack_require__(3);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _jsSha = __webpack_require__(186);
	
	var _jsSha2 = _interopRequireDefault(_jsSha);
	
	var _jsMd = __webpack_require__(187);
	
	var _jsMd2 = _interopRequireDefault(_jsMd);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.prototype.$ebqUtil = {
	  clone: function clone(obj) {
	    if (!obj) {
	      return obj;
	    }
	    var o;
	    if (obj instanceof Array) {
	      o = [];
	      for (var i = 0, len = obj.length; i < len; i++) {
	        o.push(this.clone(obj[i]));
	      }
	    } else if (obj instanceof Object) {
	      o = {};
	      for (var j in obj) {
	        o[j] = this.clone(obj[j]);
	      }
	    } else {
	      o = obj;
	    }
	    return o;
	  },
	
	  parseUrlParam: function parseUrlParam(url) {
	    var param = {};
	    if (url.indexOf("?") >= 0) {
	      url = url.split("?")[1];
	      var ps = url.split("&");
	      for (var i = 0; i < ps.length; i++) {
	        var p = ps[i].split("=");
	        param[p[0]] = p[1];
	      }
	    }
	    return param;
	  },
	
	  isEmptyObj: function isEmptyObj(obj) {
	    if (obj == null || obj == undefined) {
	      return true;
	    }
	    if ((typeof obj === 'undefined' ? 'undefined' : (0, _typeof3.default)(obj)) === "object") {
	      for (var i in obj) {
	        return false;
	      }
	    }
	    return true;
	  },
	
	  selectArrField: function selectArrField(arr, filed) {
	    if (!arr || !filed || typeof filed != "string") {
	      return [];
	    }
	    var items = [];
	    if (arr instanceof Array) {
	      for (var i = 0; i < arr.length; i++) {
	        var temp = arr[i];
	        items.push(eval("(" + "temp." + filed + ")"));
	      }
	    }
	    return items;
	  },
	
	  leftPad: function leftPad(value, size, str) {
	    if (value == null || value == undefined) {
	      return value;
	    }
	    var result = "" + value;
	    if (size <= result.length) {
	      return result;
	    }
	    var pad = typeof str === "string" && str.length == 1 ? str : "0";
	    for (var idx = result.length; idx < size; idx++) {
	      result = pad + result;
	    }
	    return result;
	  },
	  browseInfo: function browseInfo() {
	    var info = {};
	    info.ua = window.navigator.userAgent.toLowerCase();
	    if (info.ua.match(/MicroMessenger/i) == 'micromessenger') {
	      info.isWechatApp = true;
	    } else if (info.ua.match(/QQ/i) == "qq") {
	      info.isQqApp = true;
	    }
	    if (/.*((android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino).*/i.test(info.ua) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(info.ua)) {
	      info.isMobile = true;
	    }
	    return info;
	  },
	  formatFileSize: function formatFileSize(value, precision) {
	    if (typeof precision !== "number") {
	      precision = 2;
	    }
	    if (value > Math.pow(1024, 5)) {
	      return (value / Math.pow(1024, 5)).toFixed(precision) + "PB";
	    } else if (value > Math.pow(1024, 4)) {
	      return (value / Math.pow(1024, 4)).toFixed(precision) + "TB";
	    } else if (value > Math.pow(1024, 3)) {
	      return (value / Math.pow(1024, 3)).toFixed(precision) + "GB";
	    } else if (value > Math.pow(1024, 2)) {
	      return (value / Math.pow(1024, 2)).toFixed(precision) + "MB";
	    } else {
	      return (value / 1024).toFixed(precision) + "KB";
	    }
	  },
	  formatFileSizeStep: function formatFileSizeStep(value) {
	    var result = "";
	    if (value >= Math.pow(1024, 5)) {
	      result += Math.floor(value / Math.pow(1024, 5)) + "PB ";
	      value = value % Math.pow(1024, 5);
	    }
	    if (value >= Math.pow(1024, 4)) {
	      result += Math.floor(value / Math.pow(1024, 4)) + "TB ";
	      value = value % Math.pow(1024, 4);
	    }
	    if (value >= Math.pow(1024, 3)) {
	      result += Math.floor(value / Math.pow(1024, 3)) + "GB ";
	      value = value % Math.pow(1024, 3);
	    }
	    if (value >= Math.pow(1024, 2)) {
	      result += Math.floor(value / Math.pow(1024, 2)) + "MB ";
	      value = value % Math.pow(1024, 2);
	    }
	    if (value >= 1024) {
	      result += (value / 1024).toFixed(2) + "KB";
	    }
	    return result;
	  },
	  formatDuration: function formatDuration(value) {
	    if (value == null || value == undefined) {
	      return value;
	    }
	    if (value >= 3600) {
	      return parseInt(value / 3600) + "小时";
	    } else if (value >= 60) {
	      return parseInt(value / 60) + "分钟";
	    } else {
	      return value + "秒";
	    }
	  },
	  encrypt: function encrypt(eml, pwd) {
	    return (0, _jsSha2.default)(eml + (0, _jsMd2.default)(pwd));
	  },
	
	  checkCookieEnable: function checkCookieEnable() {
	    return !!navigator.cookieEnabled || (alert("开启Cookie之后才能登录"), !1);
	  }
	};

/***/ }),

/***/ 18:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(159);
	__webpack_require__(2);
	__webpack_require__(154);
	__webpack_require__(156);
	__webpack_require__(17);
	__webpack_require__(155);

/***/ }),

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.filter('formatPercent', function (value, digit) {
	    if (!value) value = 0;
	    if (!digit) digit = 1;
	    return (value * 100).toFixed(digit);
	});
	
	_vue2.default.filter('format', function (value, format) {
	    format = format || 'YYYY-MM-DD HH:mm:ss';
	    return (0, _moment2.default)(value).format(format);
	});
	_vue2.default.filter('formatDate', function (value) {
	    return (0, _moment2.default)(value).format("YYYY-MM-DD");
	});
	_vue2.default.filter('formatDateDef', function (value, def) {
	    if (!value) {
	        return def;
	    }
	    return (0, _moment2.default)(value).format("YYYY-MM-DD");
	});
	_vue2.default.filter('formatTime', function (value) {
	    return (0, _moment2.default)(value).format("HH:mm:ss");
	});
	_vue2.default.filter('formatLongTime', function (value) {
	    return (0, _moment2.default)(value).utc().format("HH:mm:ss");
	});
	_vue2.default.filter('formatDateTime', function (value) {
	    return (0, _moment2.default)(value).format("YYYY-MM-DD HH:mm:ss");
	});
	_vue2.default.filter('formatDateTimeDef', function (value, def) {
	    if (!value) {
	        return def;
	    }
	    return (0, _moment2.default)(value).format("YYYY-MM-DD HH:mm:ss");
	});
	_vue2.default.filter('formatFileSize', function (value, precision) {
	    if (typeof precision !== "number") {
	        precision = 2;
	    }
	    if (value > Math.pow(1024, 5)) {
	        return (value / Math.pow(1024, 5)).toFixed(precision) + "PB";
	    } else if (value > Math.pow(1024, 4)) {
	        return (value / Math.pow(1024, 4)).toFixed(precision) + "TB";
	    } else if (value > Math.pow(1024, 3)) {
	        return (value / Math.pow(1024, 3)).toFixed(precision) + "GB";
	    } else if (value > Math.pow(1024, 2)) {
	        return (value / Math.pow(1024, 2)).toFixed(precision) + "MB";
	    } else {
	        return (value / 1024).toFixed(precision) + "KB";
	    }
	});
	
	_vue2.default.filter('formatFileSizeStep', function (value) {
	    var result = "";
	    if (value >= Math.pow(1024, 5)) {
	        result += Math.floor(value / Math.pow(1024, 5)) + "PB ";
	        value = value % Math.pow(1024, 5);
	    }
	    if (value >= Math.pow(1024, 4)) {
	        result += Math.floor(value / Math.pow(1024, 4)) + "TB ";
	        value = value % Math.pow(1024, 4);
	    }
	    if (value >= Math.pow(1024, 3)) {
	        result += Math.floor(value / Math.pow(1024, 3)) + "GB ";
	        value = value % Math.pow(1024, 3);
	    }
	    if (value >= Math.pow(1024, 2)) {
	        result += Math.floor(value / Math.pow(1024, 2)) + "MB ";
	        value = value % Math.pow(1024, 2);
	    }
	    if (value >= 1024) {
	        result += (value / 1024).toFixed(2) + "KB";
	    }
	    return result;
	});
	
	_vue2.default.filter('leftPad', function (value, size, str) {
	    if (value == null || value == undefined) {
	        return value;
	    }
	    var result = "" + value;
	    if (size <= result.length) {
	        return result;
	    }
	    var pad = typeof str === "string" && str.length == 1 ? str : "0";
	    for (var idx = result.length; idx < size; idx++) {
	        result = pad + result;
	    }
	    return result;
	});
	
	_vue2.default.filter('leftPadZero', function (value, size) {
	    if (value == null || value == undefined) {
	        return value;
	    }
	    var result = "" + value;
	    if (size <= result.length) {
	        return result;
	    }
	    for (var idx = result.length; idx < size; idx++) {
	        result = "0" + result;
	    }
	    return result;
	});
	
	_vue2.default.filter("formatTimestamp", function (value) {
	    if (value == null || value == undefined) {
	        return value;
	    }
	    var ONE_SECOND = 1000;
	    var ONE_MIN = ONE_SECOND * 60;
	
	    var min = parseInt(value / ONE_MIN);
	
	    var result = void 0;
	
	    result = leftPad(min, 2, '0') + ':';
	
	    var remainder = value % ONE_MIN;
	
	    var second = 0;
	    if (remainder > 0) {
	        second = parseInt(remainder / ONE_SECOND);
	    }
	    result = result + leftPad(second, 2, '0');
	    return result;
	});
	
	_vue2.default.filter("formatDuration", function (value) {
	    if (value == null || value == undefined) {
	        return value;
	    }
	    if (value >= 3600) {
	        return parseInt(value / 3600) + "小时";
	    } else if (value >= 60) {
	        return parseInt(value / 60) + "分钟";
	    } else {
	        return value + "秒";
	    }
	});
	
	_vue2.default.filter("formatMilliseconds", function (value, def) {
	    if (value == null || value == undefined || value < 1) {
	        return def;
	    }
	    var result = "";
	    if (value >= 3600000) {
	        result += parseInt(value / 3600000) + "小时";
	        value = value % 3600000;
	    }
	    if (value >= 60000) {
	        result += parseInt(value / 60000) + "分钟";
	        value = value % 60000;
	    }
	    if (value > 0) {
	        result += Math.ceil(value / 1000) + "秒";
	    }
	    return result;
	});
	
	_vue2.default.filter("formatSeconds", function (value, def) {
	    if (value == null || value == undefined || value < 1) {
	        return def;
	    }
	    var result = "";
	    if (value >= 3600) {
	        result += parseInt(value / 3600) + "小时";
	        value = value % 3600;
	    }
	    if (value >= 60) {
	        result += parseInt(value / 60) + "分钟";
	        value = value % 60;
	    }
	    if (value > 0) {
	        result += Math.ceil(value) + "秒";
	    }
	    return result;
	});
	
	function leftPad(value, size, str) {
	    if (value == null || value == undefined) {
	        return value;
	    }
	    var result = "" + value;
	    if (size <= result.length) {
	        return result;
	    }
	    var pad = typeof str === "string" && str.length == 1 ? str : "0";
	    for (var idx = result.length; idx < size; idx++) {
	        result = pad + result;
	    }
	    return result;
	}

/***/ }),

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function deal(error, rule, callback, defMsg) {
	  if (error) {
	    callback(rule.message || defMsg || "不合法");
	  } else {
	    callback();
	  }
	}
	
	function dealRegex(regex, rule, val, callback, defMsg) {
	  var reg = regex || rule.regex;
	  if (rule.emptyAble && (!val || val == '')) {
	    callback();
	  } else if (!reg) {
	    callback("验证规则错误");
	  } else {
	    if (typeof reg == "string") {
	      reg = new RegExp(reg);
	    }
	    deal(!reg.test(val), rule, callback, defMsg);
	  }
	}
	
	var area = { 11: "北京", 12: "天津", 13: "河北", 14: "山西", 15: "内蒙古", 21: "辽宁", 22: "吉林", 23: "黑龙江", 31: "上海", 32: "江苏", 33: "浙江", 34: "安徽", 35: "福建", 36: "江西", 37: "山东", 41: "河南", 42: "湖北", 43: "湖南", 44: "广东", 45: "广西", 46: "海南", 50: "重庆", 51: "四川", 52: "贵州", 53: "云南", 54: "西藏", 61: "陕西", 62: "甘肃", 63: "青海", 64: "宁夏", 65: "新疆", 71: "台湾", 81: "香港", 82: "澳门", 91: "国外" };
	function dealIdCard(rule, val, callback, defMsg) {
	  if (val) {
	    var f = function f(v, i) {
	      return parseInt(v.substr(i, 1));
	    };
	    if (val.length != 15 && val.length != 18 && val.length != 8) {
	      return callback(rule.message || defMsg || "不合法1");
	    } else if (val.length == 18) {
	      var a = val.substr(0, 2);
	      if (!area[parseInt(a)]) {
	        return callback(rule.message || defMsg || "不合法2");
	      }
	      var yyyy = val.substr(6, 4),
	          mm = val.substr(10, 2),
	          dd = val.substr(12, 2);
	      var DD = new Date(yyyy + "/" + mm + "/" + dd);
	      if (!(DD.getFullYear() == yyyy && DD.getMonth() + 1 == mm && DD.getDate() == dd)) {
	        return callback(rule.message || defMsg || "不合法3");
	      }
	      var S = (f(val, 0) + f(val, 10)) * 7 + (f(val, 1) + f(val, 11)) * 9 + (f(val, 2) + f(val, 12)) * 10 + (f(val, 3) + f(val, 13)) * 5 + (f(val, 4) + f(val, 14)) * 8 + (f(val, 5) + f(val, 15)) * 4 + (f(val, 6) + f(val, 16)) * 2 + f(val, 7) * 1 + f(val, 8) * 6 + f(val, 9) * 3;
	      if (val.substr(17, 1) !== "10X98765432".substr(S % 11, 1)) {
	        return callback(rule.message || defMsg || "不合法4");
	      }
	    } else if (val.length == 15) {
	      var a = val.substr(0, 2);
	      if (!area[parseInt(a)]) {
	        return callback(rule.message || defMsg || "不合法5");
	      }
	      var yy = val.substr(6, 2),
	          mm = val.substr(8, 2),
	          dd = val.substr(10, 2);
	      var DD = new Date("19" + yy + "/" + mm + "/" + dd);
	      if (!(DD.getYear() == yy && DD.getMonth() + 1 == mm && DD.getDate() == dd)) {
	        return callback(rule.message || defMsg || "不合法6");
	      }
	    } else {
	      if (!/^[A-Z]\d{6}[A0-9]$/.test(val)) {
	        return callback(rule.message || defMsg || "不合法7");
	      }
	      var S = ((val.substr(0, 1).charCodeAt() - 64) * 8 + f(val, 1) * 7 + f(val, 2) * 6 + f(val, 3) * 5 + f(val, 4) * 4 + f(val, 5) * 3 + f(val, 6) * 2) % 11;
	      if (!(S == 0 && val.substr(7, 1) == '0' || S == 1 && val.substr(7, 1) == 'A' || f(val, 7) == 11 - S)) {
	        return callback(rule.message || defMsg || "不合法8");
	      }
	    }
	  }
	  callback();
	}
	
	_vue2.default.prototype.$validator = {
	  required: function required(rule, val, callback) {
	    deal(!val || val == "", rule, callback, "不能为空");
	  },
	  maxLength: function maxLength(rule, val, callback) {
	    var target = rule.maxLength;
	    if (!target) {
	      callback("验证规则错误");
	    } else {
	      deal(val && val.length > target, rule, callback, "不能超过" + target + "个字符");
	    }
	  },
	  minLength: function minLength(rule, val, callback) {
	    var target = rule.minLength;
	    if (!target) {
	      callback("验证规则错误");
	    } else {
	      deal(val && val.length < target, rule, callback, "不能少于" + target + "个字符");
	    }
	  },
	  lengthRank: function lengthRank(rule, val, callback) {
	    var min = rule.minLength;
	    var max = rule.maxLength;
	    if (!min || !max) {
	      callback("验证规则错误");
	    } else {
	      deal(val && (val.length < min || val.length > max), rule, callback, "输入" + min + "-" + max + "个字符");
	    }
	  },
	  maxValue: function maxValue(rule, val, callback) {
	    var target = rule.maxValue;
	    if (!target) {
	      callback("验证规则错误");
	    } else {
	      deal(val && Number(val) > target, rule, callback, "值不能大于" + target);
	    }
	  },
	  minValue: function minValue(rule, val, callback) {
	    var target = rule.minValue;
	    if (!target) {
	      callback("验证规则错误");
	    } else {
	      deal(val && Number(val) < target, rule, callback, "值不能小于" + target);
	    }
	  },
	  valueRank: function valueRank(rule, val, callback) {
	    var min = rule.minValue;
	    var max = rule.maxValue;
	    if (!min || !max) {
	      callback("验证规则错误");
	    } else {
	      deal(val && (Number(val) < min || Number(val) > max), rule, callback, "输入" + min + "-" + max + "的值");
	    }
	  },
	  regex: function regex(rule, val, callback) {
	    dealRegex(null, rule, val, callback);
	  },
	  idCard: function idCard(rule, val, callback) {
	    dealIdCard(rule, val, callback, "不是合法的身份证号");
	  },
	  certificateNo: function certificateNo(rule, val, callback) {
	    if (/^[A-Z0-9]{12,18}$/.test(val)) {
	      callback();
	    } else {
	      dealIdCard(rule, val, callback, "不是合法的证件号");
	    }
	  },
	  specialVal: function specialVal(rule, val, callback) {
	    dealRegex(/^[^-`=\\\[\];',.\/~!@#$￥！……%^&*()_+|{}:"<>?\s]*$/, rule, val, callback, "不能包含特殊字符");
	  },
	  businessLicenseVal: function businessLicenseVal(rule, val, callback) {
	    dealRegex(/^[A-Z0-9]{12,18}$/, rule, val, callback, "不是合法的营业执照号");
	  },
	  bankCard: function bankCard(rule, val, callback) {
	    dealRegex(/^[0-9]{16,21}$/, rule, val, callback, "不是合法的银行卡号");
	  },
	  mobile: function mobile(rule, val, callback) {
	    dealRegex(/^1[1-9]\d{9}$/, rule, val, callback, "不是合法的手机号");
	  },
	  email: function email(rule, val, callback) {
	    dealRegex(/^[\w.]+@[\w.]{3,}$/, rule, val, callback, "不是合法的邮箱");
	  },
	  password: function password(rule, val, callback) {
	    dealRegex(/^(?!\d{6,16}$)[\S]{6,16}$/, rule, val, callback, "不是合法的密码");
	  },
	  number: function number(rule, val, callback) {
	    dealRegex(/^[+\-]?\d+(\.\d+)?$/, rule, val, callback, "不是合法的数值");
	  },
	  integer: function integer(rule, val, callback) {
	    dealRegex(/^\d+$/, rule, val, callback, "不是合法的数字");
	  },
	  mobileOrEmail: function mobileOrEmail(rule, val, callback) {
	    dealRegex(/^(1[1-9]\d{9})|([\w.]+@[\w.]{3,})$/, rule, val, callback, "不是手机或者邮箱");
	  }
	};

/***/ }),

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(157);
	__webpack_require__(158);

/***/ }),

/***/ 157:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof2 = __webpack_require__(3);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.directive('focus', {
	  inserted: function inserted(el, _ref) {
	    var value = _ref.value;
	
	    if (typeof value === "undefined") {
	      el.focus();
	    } else if (typeof value === "boolean") {
	      if (value) el.focus();
	    } else if ((typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) === "object") {
	      if (value.focus) el.focus();
	      if (value.select) el.select();
	    }
	  }
	});

/***/ }),

/***/ 158:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	var _typeof2 = __webpack_require__(3);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _layer = __webpack_require__(5);
	
	var _layer2 = _interopRequireDefault(_layer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.directive('tips', {
	  inserted: function inserted(el, _ref) {
	    var value = _ref.value;
	
	    var msg = null;
	    if (typeof value === "string") {
	      msg = value;
	    } else if ((typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) === "object") {
	      msg = value.msg;
	    }
	
	    var layerIndex = null;
	    $(el).mouseover(function () {
	      layerIndex = _layer2.default.tips(msg, el, { tips: [1, '#3595CC'], time: 3000 });
	    }).mouseout(function () {
	      _layer2.default.close(layerIndex);
	    });
	  }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),

/***/ 159:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	var _typeof2 = __webpack_require__(3);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _stringify = __webpack_require__(15);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _getOwnPropertyNames = __webpack_require__(191);
	
	var _getOwnPropertyNames2 = _interopRequireDefault(_getOwnPropertyNames);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _GlobalConfig = __webpack_require__(2);
	
	var _GlobalConfig2 = _interopRequireDefault(_GlobalConfig);
	
	var _corsAjax = __webpack_require__(11);
	
	var _corsAjax2 = _interopRequireDefault(_corsAjax);
	
	var _layer = __webpack_require__(5);
	
	var _layer2 = _interopRequireDefault(_layer);
	
	var _vueCookie = __webpack_require__(10);
	
	var _vueCookie2 = _interopRequireDefault(_vueCookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function doFunction(callback) {
	  if (typeof callback === "function") {
	    callback();
	  }
	}
	var isSync = false;
	var callbackList = [];
	var Vpermission = '';
	function doAfterSyncLogin(vue, callback, syncLogin, loginType, permission) {
	  if (permission) {
	    Vpermission = permission;
	  }
	  loginType = loginType || _GlobalConfig2.default.defaultLoginType;
	  if (syncLogin) {
	    localStorage.clear();
	    vue.loginUser = {};
	  }
	  var token = _vueCookie2.default.get("token");
	  if (!token) {
	    var url = window.location.href;
	    var domain = _GlobalConfig2.default.domain.forensicsWebOp;
	    if (!url.startsWith(domain + "/login.html") && !url.startsWith(domain + "/resetPwd.html") && !url.startsWith(domain + "/register.html")) {
	      toAccountAuth();
	    } else {}
	  } else {
	    if (isSync) {
	      var cnt = 0;
	      var timer = window.setInterval(function () {
	        var hasToken = localStorage.getItem(_GlobalConfig2.default.STORAGE_TOKEN_NAME);
	        if (hasToken) {
	          window.clearInterval(timer);
	          Vpermission && checkPermissions(vue, Vpermission);
	          vue.loginUser = JSON.parse(localStorage.getItem(_GlobalConfig2.default.STORAGE_USER));
	          if (vue.parentUserInfo && (0, _getOwnPropertyNames2.default)(vue.parentUserInfo).length > 1) {
	            doFunction(callback);
	            dealCallbackList(vue);
	          } else {
	            callbackList.push(callback);
	          }
	        } else if (++cnt >= 50) {
	          window.clearInterval(timer);
	          dealCallbackList(vue);
	        }
	      }, 100);
	      return;
	    }
	    isSync = true;
	    doAfterTokenCheck(vue, callback, loginType, token);
	  }
	}
	
	function dealCallbackList(vue) {
	  while (callbackList.length) {
	    try {
	      doFunction(callbackList.shift());
	    } catch (e) {
	      console.log(e);
	    }
	    if (!callbackList.length) {}
	  }
	}
	function doAfterApiSyncLogin(vue, callback, loginType) {
	  (0, _corsAjax2.default)({
	    url: _GlobalConfig2.default.domain.accountWeb + "/login/syncLogin?r=" + Math.random(),
	    method: "post",
	    withCredentials: true,
	    success: function success(response) {
	      isSync = false;
	      console.log("user form syncLogin:" + response.success);
	      if (response.success) {
	        localStorage.setItem(_GlobalConfig2.default.STORAGE_TOKEN_NAME, response.data.token);
	        localStorage.setItem(_GlobalConfig2.default.STORAGE_USER, (0, _stringify2.default)(response.data.loginUser));
	        vue.loginUser = response.data.loginUser;
	        syncChildren(vue, vue.loginUser);
	        doFunction(callback);
	      } else {
	        localStorage.clear();
	        vue.loginUser = {};
	
	        if (loginType == 1) {
	          window.location.href = _GlobalConfig2.default.domain.forensicsWebOp + "/login.html?returnURL=" + encodeURIComponent(location.href);
	        } else if (loginType == 2) {
	          _layer2.default.open({
	            type: 2,
	            title: false,
	            icon: 2,
	            closeBtn: 0,
	            area: ['400px', '480px'],
	            fixed: false,
	            content: [_GlobalConfig2.default.domain.accountWeb + '/plogin/loginPage?corsUrl=' + encodeURIComponent(_GlobalConfig2.default.domain.athenaWebUms + "/login-cors.html"), 'no'],
	            success: function success() {
	              $(".layui-layer-iframe,.layui-layer-content").css("border-radius", "10px");
	            }
	          });
	        } else {}
	      }
	    }
	  });
	}
	
	function toAccountAuth() {
	  var ap = encodeURIComponent(location.href);
	  var cp = encodeURIComponent(_GlobalConfig2.default.domain.forensicsWebOp + "/author.html");
	  var lp = encodeURIComponent(_GlobalConfig2.default.domain.forensicsWebOp + "/login.html");
	  window.location.href = _GlobalConfig2.default.domain.accountWeb + "/login/authorization?ap=" + ap + "&cp=" + cp + "&lp=" + lp;
	}
	function doAfterTokenCheck(vue, callback, loginType, token) {
	  (0, _corsAjax2.default)({
	    url: _GlobalConfig2.default.domain.accountWeb + "/sso/tkcheck?t=" + token + "&r=" + Math.random(),
	    method: "post",
	    withCredentials: true,
	    success: function success(response) {
	      isSync = false;
	      console.log("user form syncLogin:" + response.success);
	      if (response.success) {
	        localStorage.setItem(_GlobalConfig2.default.STORAGE_TOKEN_NAME, response.data.token);
	        localStorage.setItem(_GlobalConfig2.default.STORAGE_USER, (0, _stringify2.default)(response.data.loginUser));
	        vue.loginUser = response.data.loginUser;
	        syncChildren(vue, vue.loginUser, 'loginUser');
	        getParentUserInfo(vue, callback);
	      } else {
	        localStorage.clear();
	        _vueCookie2.default.delete(_GlobalConfig2.default.COOKIE_TOKEN_NAME);
	        vue.loginUser = {};
	        if (loginType == 1) {
	          toAccountAuth();
	        } else if (loginType == 2) {
	          _layer2.default.open({
	            type: 2,
	            title: false,
	            icon: 2,
	            closeBtn: 0,
	            area: ['400px', '480px'],
	            fixed: false,
	            content: [_GlobalConfig2.default.domain.accountWeb + '/plogin/loginPage?corsUrl=' + encodeURIComponent(_GlobalConfig2.default.domain.forensicsWebOp + "/login-cors.html"), 'no'],
	            success: function success() {
	              $(".layui-layer-iframe,.layui-layer-content").css("border-radius", "10px");
	            }
	          });
	        } else {}
	      }
	    }
	  });
	}
	function getParentUserInfo(vue, callback) {
	  (0, _corsAjax2.default)({
	    url: _GlobalConfig2.default.domain.forensicsBackstage + "/account/user/profile",
	    method: "get",
	    withCredentials: true,
	    success: function success(response) {
	      if (response.success) {
	        vue.parentUserInfo = response.data || {};
	        syncChildren(vue, vue.parentUserInfo, 'parentUserInfo');
	      }
	      Vpermission && checkPermissions(vue, Vpermission);
	      dealCallbackList(vue);
	      doFunction(callback);
	    }
	  });
	}
	function syncChildren(vue, loginUser, key) {
	  var arr = vue.$children;
	  if (arr.length < 1) {
	    return;
	  } else {
	    for (var idx = 0; idx < arr.length; idx++) {
	      arr[idx][key] = loginUser;
	      syncChildren(arr[idx], loginUser, key);
	    }
	  }
	}
	
	function checkPermissions(vue, permission) {
	  var status = false;
	  if (vue.parentUserInfo) {
	    if (vue.parentUserInfo.operatorType !== 3) {
	      return true;
	    }
	    if (vue.parentUserInfo.permissionCodes) {
	      status = vue.parentUserInfo.permissionCodes.indexOf(permission) > -1;
	    }
	    if (!status) {
	      Vpermission = '';
	      location.href = '/withoutPower.html';
	    }
	  }
	}
	
	function updateLocalUser(vue, loginUser) {
	  if (loginUser && (typeof loginUser === 'undefined' ? 'undefined' : (0, _typeof3.default)(loginUser)) === "object") {
	    localStorage.setItem(_GlobalConfig2.default.STORAGE_USER, (0, _stringify2.default)(loginUser));
	  } else {
	    doAfterSyncLogin(vue);
	  }
	}
	
	window.layerIframeAuto = function (wn, height) {
	  var index = _layer2.default.getFrameIndex(wn);
	  var layuiLayer = $("#layui-layer" + index);
	  var layuiLayerIframe = layuiLayer.find("iframe");
	  layuiLayer.css("height", height);
	  layuiLayerIframe.css("height", height);
	};
	window.flushAfterLogin = function () {
	  window.location.href = window.location.href;
	};
	
	_vue2.default.prototype.doAfterSyncLogin = doAfterSyncLogin;
	_vue2.default.prototype.updateLocalUser = updateLocalUser;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),

/***/ 161:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 179:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 19,
		"./af.js": 19,
		"./ar": 26,
		"./ar-dz": 20,
		"./ar-dz.js": 20,
		"./ar-kw": 21,
		"./ar-kw.js": 21,
		"./ar-ly": 22,
		"./ar-ly.js": 22,
		"./ar-ma": 23,
		"./ar-ma.js": 23,
		"./ar-sa": 24,
		"./ar-sa.js": 24,
		"./ar-tn": 25,
		"./ar-tn.js": 25,
		"./ar.js": 26,
		"./az": 27,
		"./az.js": 27,
		"./be": 28,
		"./be.js": 28,
		"./bg": 29,
		"./bg.js": 29,
		"./bm": 30,
		"./bm.js": 30,
		"./bn": 32,
		"./bn-bd": 31,
		"./bn-bd.js": 31,
		"./bn.js": 32,
		"./bo": 33,
		"./bo.js": 33,
		"./br": 34,
		"./br.js": 34,
		"./bs": 35,
		"./bs.js": 35,
		"./ca": 36,
		"./ca.js": 36,
		"./cs": 37,
		"./cs.js": 37,
		"./cv": 38,
		"./cv.js": 38,
		"./cy": 39,
		"./cy.js": 39,
		"./da": 40,
		"./da.js": 40,
		"./de": 43,
		"./de-at": 41,
		"./de-at.js": 41,
		"./de-ch": 42,
		"./de-ch.js": 42,
		"./de.js": 43,
		"./dv": 44,
		"./dv.js": 44,
		"./el": 45,
		"./el.js": 45,
		"./en-au": 46,
		"./en-au.js": 46,
		"./en-ca": 47,
		"./en-ca.js": 47,
		"./en-gb": 48,
		"./en-gb.js": 48,
		"./en-ie": 49,
		"./en-ie.js": 49,
		"./en-il": 50,
		"./en-il.js": 50,
		"./en-in": 51,
		"./en-in.js": 51,
		"./en-nz": 52,
		"./en-nz.js": 52,
		"./en-sg": 53,
		"./en-sg.js": 53,
		"./eo": 54,
		"./eo.js": 54,
		"./es": 58,
		"./es-do": 55,
		"./es-do.js": 55,
		"./es-mx": 56,
		"./es-mx.js": 56,
		"./es-us": 57,
		"./es-us.js": 57,
		"./es.js": 58,
		"./et": 59,
		"./et.js": 59,
		"./eu": 60,
		"./eu.js": 60,
		"./fa": 61,
		"./fa.js": 61,
		"./fi": 62,
		"./fi.js": 62,
		"./fil": 63,
		"./fil.js": 63,
		"./fo": 64,
		"./fo.js": 64,
		"./fr": 67,
		"./fr-ca": 65,
		"./fr-ca.js": 65,
		"./fr-ch": 66,
		"./fr-ch.js": 66,
		"./fr.js": 67,
		"./fy": 68,
		"./fy.js": 68,
		"./ga": 69,
		"./ga.js": 69,
		"./gd": 70,
		"./gd.js": 70,
		"./gl": 71,
		"./gl.js": 71,
		"./gom-deva": 72,
		"./gom-deva.js": 72,
		"./gom-latn": 73,
		"./gom-latn.js": 73,
		"./gu": 74,
		"./gu.js": 74,
		"./he": 75,
		"./he.js": 75,
		"./hi": 76,
		"./hi.js": 76,
		"./hr": 77,
		"./hr.js": 77,
		"./hu": 78,
		"./hu.js": 78,
		"./hy-am": 79,
		"./hy-am.js": 79,
		"./id": 80,
		"./id.js": 80,
		"./is": 81,
		"./is.js": 81,
		"./it": 83,
		"./it-ch": 82,
		"./it-ch.js": 82,
		"./it.js": 83,
		"./ja": 84,
		"./ja.js": 84,
		"./jv": 85,
		"./jv.js": 85,
		"./ka": 86,
		"./ka.js": 86,
		"./kk": 87,
		"./kk.js": 87,
		"./km": 88,
		"./km.js": 88,
		"./kn": 89,
		"./kn.js": 89,
		"./ko": 90,
		"./ko.js": 90,
		"./ku": 91,
		"./ku.js": 91,
		"./ky": 92,
		"./ky.js": 92,
		"./lb": 93,
		"./lb.js": 93,
		"./lo": 94,
		"./lo.js": 94,
		"./lt": 95,
		"./lt.js": 95,
		"./lv": 96,
		"./lv.js": 96,
		"./me": 97,
		"./me.js": 97,
		"./mi": 98,
		"./mi.js": 98,
		"./mk": 99,
		"./mk.js": 99,
		"./ml": 100,
		"./ml.js": 100,
		"./mn": 101,
		"./mn.js": 101,
		"./mr": 102,
		"./mr.js": 102,
		"./ms": 104,
		"./ms-my": 103,
		"./ms-my.js": 103,
		"./ms.js": 104,
		"./mt": 105,
		"./mt.js": 105,
		"./my": 106,
		"./my.js": 106,
		"./nb": 107,
		"./nb.js": 107,
		"./ne": 108,
		"./ne.js": 108,
		"./nl": 110,
		"./nl-be": 109,
		"./nl-be.js": 109,
		"./nl.js": 110,
		"./nn": 111,
		"./nn.js": 111,
		"./oc-lnc": 112,
		"./oc-lnc.js": 112,
		"./pa-in": 113,
		"./pa-in.js": 113,
		"./pl": 114,
		"./pl.js": 114,
		"./pt": 116,
		"./pt-br": 115,
		"./pt-br.js": 115,
		"./pt.js": 116,
		"./ro": 117,
		"./ro.js": 117,
		"./ru": 118,
		"./ru.js": 118,
		"./sd": 119,
		"./sd.js": 119,
		"./se": 120,
		"./se.js": 120,
		"./si": 121,
		"./si.js": 121,
		"./sk": 122,
		"./sk.js": 122,
		"./sl": 123,
		"./sl.js": 123,
		"./sq": 124,
		"./sq.js": 124,
		"./sr": 126,
		"./sr-cyrl": 125,
		"./sr-cyrl.js": 125,
		"./sr.js": 126,
		"./ss": 127,
		"./ss.js": 127,
		"./sv": 128,
		"./sv.js": 128,
		"./sw": 129,
		"./sw.js": 129,
		"./ta": 130,
		"./ta.js": 130,
		"./te": 131,
		"./te.js": 131,
		"./tet": 132,
		"./tet.js": 132,
		"./tg": 133,
		"./tg.js": 133,
		"./th": 134,
		"./th.js": 134,
		"./tk": 135,
		"./tk.js": 135,
		"./tl-ph": 136,
		"./tl-ph.js": 136,
		"./tlh": 137,
		"./tlh.js": 137,
		"./tr": 138,
		"./tr.js": 138,
		"./tzl": 139,
		"./tzl.js": 139,
		"./tzm": 141,
		"./tzm-latn": 140,
		"./tzm-latn.js": 140,
		"./tzm.js": 141,
		"./ug-cn": 142,
		"./ug-cn.js": 142,
		"./uk": 143,
		"./uk.js": 143,
		"./ur": 144,
		"./ur.js": 144,
		"./uz": 146,
		"./uz-latn": 145,
		"./uz-latn.js": 145,
		"./uz.js": 146,
		"./vi": 147,
		"./vi.js": 147,
		"./x-pseudo": 148,
		"./x-pseudo.js": 148,
		"./yo": 149,
		"./yo.js": 149,
		"./zh-cn": 150,
		"./zh-cn.js": 150,
		"./zh-hk": 151,
		"./zh-hk.js": 151,
		"./zh-mo": 152,
		"./zh-mo.js": 152,
		"./zh-tw": 153,
		"./zh-tw.js": 153
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 192;


/***/ }),

/***/ 283:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	__webpack_require__(8);
	
	var _http = __webpack_require__(4);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _corsAjax = __webpack_require__(11);
	
	var _corsAjax2 = _interopRequireDefault(_corsAjax);
	
	var _GlobalConfig = __webpack_require__(2);
	
	var _GlobalConfig2 = _interopRequireDefault(_GlobalConfig);
	
	var _layer = __webpack_require__(5);
	
	var _layer2 = _interopRequireDefault(_layer);
	
	var _vueCookie = __webpack_require__(10);
	
	var _vueCookie2 = _interopRequireDefault(_vueCookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'op-header',
	  data: function data() {
	    return {
	      isActive: false,
	      loginUser: {},
	      parentUserInfo: {}
	    };
	  },
	  created: function created() {
	    var _this = this;
	    this.doAfterSyncLogin(_this, function () {}, true, 1);
	  },
	
	  methods: {
	    settings: function settings() {
	      window.open(_GlobalConfig2.default.domain.accountWeb + '/profile?hm=1');
	    },
	    clickSignIn: function clickSignIn() {
	      var _thisVue = this;
	      _http2.default.post(_GlobalConfig2.default.domain.forensicsBackstage + "/account/signIn", {}, function (response) {
	        var result = response.data;
	        if (result.success) {
	          _thisVue.loginUser.signIn = true;
	          _thisVue.loginUser.point = result.data.point;
	          _thisVue.updateLocalUser(_thisVue);
	          _layer2.default.alert(result.message, { icon: 1, title: '系统提示' });
	        } else if (result.code == 401) {
	          _layer2.default.alert("登录已过期，请重新登录", { icon: 5, title: "系统提示" });
	        } else {
	          _layer2.default.alert(result.message, { icon: 5, title: "系统提示" });
	        }
	      });
	    },
	    userDetailShow: function userDetailShow() {
	      this.isActive = true;
	    },
	    userDetailHide: function userDetailHide() {
	      this.isActive = true;
	    },
	    userInfoHide: function userInfoHide() {
	      this.isActive = false;
	    },
	    clearLocalInfo: function clearLocalInfo() {
	      localStorage.clear();
	      _vueCookie2.default.delete("token");
	    },
	    gotoLogin: function gotoLogin() {
	      window.location.href = _GlobalConfig2.default.domain.forensicsWebOp + "/login.html";
	    },
	    toIdentity: function toIdentity() {
	      window.location.href = _GlobalConfig2.default.domain.accountWeb + '/userAuth/identity?productType=2&backUrl=' + encodeURIComponent(window.location.href);
	    }
	  }
	};

/***/ }),

/***/ 303:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 305:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/dcqz.8e8c600.png";

/***/ }),

/***/ 306:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/logo.b1bf463.png";

/***/ }),

/***/ 307:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/qdht.4e53a45.png";

/***/ }),

/***/ 308:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo4MUZENTM5RjRBODkxMUU3ODhBREE0OUYwMjgyRjAzQyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo4MUZENTNBMDRBODkxMUU3ODhBREE0OUYwMjgyRjAzQyI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjgxRkQ1MzlENEE4OTExRTc4OEFEQTQ5RjAyODJGMDNDIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjgxRkQ1MzlFNEE4OTExRTc4OEFEQTQ5RjAyODJGMDNDIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+ZKjergAAAVxJREFUeNqs1MsrRGEYx3EHO0ku2dnYui6kmIi9tSJFySUxE4qyslESReO+oFkoC38EGcqGnY2FRLkMM2VBlI7vyZOeecycRs1bn/PW+57zO+e8N8d13ZxslHzvUhx5su0l6EQAVXBwiRMcIOmBRG/5T5Apg1hAkWmvR7f0TWFdd+aam+exlSJElwKsIZwuqA/T/xiWUQzZoELsZhgQRxfOsIkyHdSTYcgLqrGPmPqT36A2qV99QhIyg/fYRoe0t+ugRqkrUIl3E/KMWjxiAwOqL6CDvqQexzXq8KFCanAnYzJsXpKng86lnsUirtCEKBrwgBU9S6pEddCx6pjEMi7QghtZN8E0Y3eog/ZMZwhzsjWWMOIzCREdFE/x2TMyxRM+IUH57aSV7U3pqrmx1CdkR28Tu9fG5C1vPgGf8pX9f44RU8JyVHg7vRmtMsVHOJVVfWsfcrJ1sH0LMADX2UmAwt9mbAAAAABJRU5ErkJggg=="

/***/ }),

/***/ 309:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/wenhao.477a5ce.png";

/***/ }),

/***/ 310:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/zscq.e183841.png";

/***/ }),

/***/ 313:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(303)
	
	/* script */
	__vue_exports__ = __webpack_require__(283)
	
	/* template */
	var __vue_template__ = __webpack_require__(316)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-53bf23d3"
	
	module.exports = __vue_exports__


/***/ }),

/***/ 316:
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('nav', [_c('div', {
	    staticClass: "navbar-top",
	    staticStyle: {
	      "height": "inherit",
	      "background-color": "#333333"
	    }
	  }, [_c('ul', {
	    staticClass: "tableshow",
	    staticStyle: {
	      "margin": "0"
	    }
	  }, [_c('li', {
	    staticClass: "fixed text-center",
	    staticStyle: {
	      "vertical-align": "top",
	      "background-color": "#333333"
	    }
	  }, [_c('div', {
	    staticClass: "userba"
	  }, [_c('a', {
	    attrs: {
	      "href": _vm.globalConfig.domain.portal
	    }
	  }, [_c('img', {
	    staticStyle: {
	      "width": "150px"
	    },
	    attrs: {
	      "src": __webpack_require__(306),
	      "alt": ""
	    }
	  })])])]), _vm._v(" "), _c('li', {
	    staticClass: "tablecell respond",
	    staticStyle: {
	      "background": "#333"
	    }
	  }, [_c('div', {
	    staticClass: "pull-right userba",
	    staticStyle: {
	      "margin-right": "225px"
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": _vm.globalConfig.domain.portal + '/services',
	      "title": "数据保全-服务与支持"
	    }
	  }, [_c('img', {
	    staticClass: "tf",
	    attrs: {
	      "src": __webpack_require__(309),
	      "alt": "数据保全-服务与支持"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "pull-right userba",
	    staticStyle: {
	      "margin-right": "50px"
	    }
	  }, [(_vm.parentUserInfo.userId) ? [_c('div', {
	    staticClass: "text-center"
	  }, [_c('div', {
	    staticClass: "block-userinfo userbar"
	  }, [_c('a', {
	    staticClass: "username nomargin",
	    staticStyle: {
	      "padding-left": "0",
	      "padding-right": "0",
	      "text-align": "left",
	      "color": "#ffffff"
	    },
	    attrs: {
	      "href": "javascript:void(0)",
	      "id": "addyangxin_div_block"
	    },
	    on: {
	      "mouseover": function($event) {
	        return _vm.userDetailShow()
	      },
	      "mouseleave": function($event) {
	        return _vm.userDetailHide()
	      }
	    }
	  }, [_c('img', {
	    staticClass: "tf",
	    staticStyle: {
	      "margin-right": "20px",
	      "border-radius": "50%"
	    },
	    attrs: {
	      "src": _vm.loginUser.realImgPath || '/static/img/defaultUserImg.jpg'
	    }
	  }), _vm._v("\n                    " + _vm._s(_vm.parentUserInfo.userName) + "\n                  ")]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (this.isActive),
	      expression: "this.isActive"
	    }],
	    staticClass: "user-info user",
	    attrs: {
	      "id": "addyangxin_userInformation"
	    },
	    on: {
	      "mouseleave": function($event) {
	        return _vm.userInfoHide()
	      }
	    }
	  }, [_c('div', {
	    staticClass: "sidebar-userinfo"
	  }, [_c('div', {
	    staticClass: "row nomargin"
	  }, [_c('div', {
	    staticClass: "col-xs-12 photomove"
	  }, [_c('a', {
	    attrs: {
	      "href": _vm.globalConfig.domain.accountWeb + '/profile?hm=1',
	      "alt": "",
	      "target": "_blank"
	    }
	  }, [_c('img', {
	    staticClass: "user-photo",
	    attrs: {
	      "src": _vm.loginUser.realImgPath || '/static/img/defaultUserImg.jpg',
	      "alt": _vm.parentUserInfo.userName
	    }
	  })]), _vm._v(" "), _c('img', {
	    staticClass: "realN",
	    attrs: {
	      "src": __webpack_require__(308)
	    },
	    on: {
	      "click": _vm.toIdentity
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "account-setting",
	    attrs: {
	      "title": "设置"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.settings()
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-12 loginuser"
	  }, [_c('h5', {
	    staticStyle: {
	      "width": "90px",
	      "margin-bottom": "4px",
	      "-ms-flex-wrap": "nowrap",
	      "flex-wrap": "nowrap",
	      "overflow": "hidden",
	      "white-space": "nowrap",
	      "text-overflow": "ellipsis"
	    }
	  }, [_vm._v(_vm._s(_vm.parentUserInfo.userName))])])]), _vm._v(" "), _c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "border-bottom": "1px solid #dedede"
	    }
	  }, [_c('div', {
	    staticClass: "col-xs-7"
	  }, [_c('h5', [_vm._v("积分数量："), _c('span', {
	    staticClass: "color-primary",
	    attrs: {
	      "id": "head_user_point"
	    }
	  }, [_vm._v(_vm._s(_vm.parentUserInfo.point))])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-5"
	  }, [(_vm.parentUserInfo.userType == 0) ? [_c('a', {
	    staticClass: "light-gray",
	    attrs: {
	      "href": _vm.globalConfig.domain.accountWeb + '/asset/toPointTask',
	      "target": "_blank"
	    }
	  }, [_vm._v("积分任务")])] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "row userba"
	  }, [_c('div', {
	    staticClass: "col-xs-6 nopadding"
	  }, [_c('img', {
	    staticClass: "tf",
	    attrs: {
	      "src": __webpack_require__(307),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('a', {
	    staticClass: "pagefont-color",
	    attrs: {
	      "href": _vm.globalConfig.domain.junziqianWebOp,
	      "alt": "",
	      "target": "_blank"
	    }
	  }, [_vm._v("我的合同")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-6 nopadding"
	  }, [_c('img', {
	    staticClass: "tf",
	    attrs: {
	      "src": __webpack_require__(310),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('a', {
	    staticClass: "pagefont-color",
	    attrs: {
	      "href": _vm.globalConfig.domain.athenaWebUms,
	      "alt": "",
	      "target": "_blank"
	    }
	  }, [_vm._v("我的原创")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row  userba"
	  }, [_c('div', {
	    staticClass: "col-xs-6 nopadding"
	  }, [_c('img', {
	    staticClass: "tf",
	    attrs: {
	      "src": __webpack_require__(305),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('a', {
	    staticClass: "pagefont-color",
	    attrs: {
	      "href": _vm.globalConfig.domain.forensicsWebOp,
	      "alt": ""
	    }
	  }, [_vm._v("证据存证")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "background-color": "#f0f0f0"
	    }
	  }, [_c('div', {
	    staticClass: "col-xs-6 text-left"
	  }, [(_vm.parentUserInfo.userType == 0) ? [(!_vm.loginUser.signIn) ? _c('button', {
	    staticClass: "btn btn-danger btn-signin",
	    on: {
	      "click": function($event) {
	        return _vm.clickSignIn()
	      }
	    }
	  }, [_vm._v("签到")]) : _c('button', {
	    staticClass: "btn btn-danger btn-signin",
	    attrs: {
	      "disabled": "disabled"
	    }
	  }, [_vm._v("已签到")])] : _vm._e()], 2), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-6 text-right"
	  }, [_c('a', {
	    staticClass: "light-gray",
	    attrs: {
	      "href": _vm.globalConfig.domain.accountWeb + '/login/accountLogout?returnURL=' + _vm.globalConfig.domain.forensicsWebOp + '/login.html'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.clearLocalInfo()
	      }
	    }
	  }, [_vm._v("退出")])])])])])])])] : [_c('div', {
	    staticClass: "pull-right userba"
	  }, [_c('a', {
	    staticStyle: {
	      "color": "#fff"
	    },
	    attrs: {
	      "href": _vm.globalConfig.domain.forensicsWebOp + '/register.html'
	    }
	  }, [_vm._v("注册")])]), _vm._v(" "), _c('div', {
	    staticClass: "pull-right userba"
	  }, [_c('a', {
	    staticStyle: {
	      "padding": "0px 15px",
	      "color": "#fff"
	    },
	    attrs: {
	      "href": "javascript:void(0);"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.gotoLogin()
	      }
	    }
	  }, [_vm._v("\n                  登录\n                ")])])]], 2)])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 349:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(263);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(262);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _http = __webpack_require__(4);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _es6Promise = __webpack_require__(160);
	
	var _GlobalConfig = __webpack_require__(2);
	
	var _GlobalConfig2 = _interopRequireDefault(_GlobalConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      captcha: null,
	      captchaButton: null
	    };
	  },
	
	  props: ["handCallback", "verify", "targetId", "verifyType", "mobileOrEmail"],
	
	  computed: {},
	
	  watch: {},
	
	  methods: {
	    getInstance: function getInstance(instance) {
	      this.captcha = instance;
	    },
	    captchaVerifyCallback: function captchaVerifyCallback(captchaVerifyParam) {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                return _context2.abrupt('return', new _es6Promise.Promise(function (resolve, reject) {
	                  if (_this.verify) _this.verify((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	                    var param, targetId, verifyType, mobileOrEmail, res, _res$data, captchaVerifyResult, sendVerifyCodeResult, sendVerifyCodeInfo, sendVerifyCodeMsg, sendVerifyCodeResultCode;
	
	                    return _regenerator2.default.wrap(function _callee$(_context) {
	                      while (1) {
	                        switch (_context.prev = _context.next) {
	                          case 0:
	                            param = {
	                              captchaVerifyParam: captchaVerifyParam,
	                              source: 1,
	                              targetId: '',
	                              origin: 'ebq' };
	                            targetId = _this.targetId, verifyType = _this.verifyType, mobileOrEmail = _this.mobileOrEmail;
	
	                            if (targetId) param.targetId = targetId;
	                            if (mobileOrEmail) param.mobileOrEmail = mobileOrEmail;
	                            res = null;
	                            _context.t0 = verifyType;
	                            _context.next = _context.t0 === 1 ? 8 : _context.t0 === 2 ? 12 : 16;
	                            break;
	
	                          case 8:
	                            _context.next = 10;
	                            return _this.loginNotic(param);
	
	                          case 10:
	                            res = _context.sent;
	                            return _context.abrupt('break', 17);
	
	                          case 12:
	                            _context.next = 14;
	                            return _this.registerNotic(param);
	
	                          case 14:
	                            res = _context.sent;
	                            return _context.abrupt('break', 17);
	
	                          case 16:
	                            return _context.abrupt('break', 17);
	
	                          case 17:
	                            if (res.success) {
	                              _context.next = 19;
	                              break;
	                            }
	
	                            return _context.abrupt('return', { captchaResult: false });
	
	                          case 19:
	                            _res$data = res.data, captchaVerifyResult = _res$data.captchaVerifyResult, sendVerifyCodeResult = _res$data.sendVerifyCodeResult, sendVerifyCodeInfo = _res$data.sendVerifyCodeInfo, sendVerifyCodeMsg = _res$data.sendVerifyCodeMsg, sendVerifyCodeResultCode = _res$data.sendVerifyCodeResultCode;
	
	                            if (captchaVerifyResult && sendVerifyCodeResult) _this.$message.success('短信发送成功');
	                            if (captchaVerifyResult && !sendVerifyCodeResult) _this.$message.error(sendVerifyCodeMsg || '发送失败');
	                            resolve({
	                              captchaResult: captchaVerifyResult,
	                              bizResult: Boolean(sendVerifyCodeResult) });
	
	                          case 23:
	                          case 'end':
	                            return _context.stop();
	                        }
	                      }
	                    }, _callee, _this);
	                  })));
	                }));
	
	              case 1:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this);
	      }))();
	    },
	    onBizResultCallback: function onBizResultCallback(bizResult) {
	      if (this.handCallback && bizResult) this.handCallback();
	    },
	    loginNotic: function loginNotic(param) {
	      return new _es6Promise.Promise(function (resole, reject) {
	        var url = _GlobalConfig2.default.domain.accountWeb + '/validateCode/aliCaptchaToSendLoginCode';
	        _http2.default.post(url, param, function (response) {
	          resole(response.data);
	        });
	      });
	    },
	    registerNotic: function registerNotic(param) {
	      return new _es6Promise.Promise(function (resole, reject) {
	        var url = _GlobalConfig2.default.domain.accountWeb + '/validateCode/aliCaptchaToSendAuthCode/mobileRegister';
	        _http2.default.post(url, param, function (response) {
	          resole(response.data);
	        });
	      });
	    }
	  },
	  created: function created() {},
	  mounted: function mounted() {
	    this.captchaButton = document.getElementById('captcha-button');
	    window.initAliyunCaptcha({
	      SceneId: '10lq13vq',
	      prefix: 'lvkajq',
	      mode: 'popup',
	      element: '#captcha-element',
	      button: '#captcha-button',
	      captchaVerifyCallback: this.captchaVerifyCallback,
	      onBizResultCallback: this.onBizResultCallback,
	      getInstance: this.getInstance,
	      slideStyle: {
	        width: 360,
	        height: 40
	      },
	      language: 'cn' });
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.captchaButton = null;
	
	    var mask = document.getElementById('aliyunCaptcha-mask'),
	        popup = document.getElementById('aliyunCaptcha-window-popup');
	    if (mask) mask.remove();
	    if (popup) popup.remove();
	  }
	};

/***/ }),

/***/ 397:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 401:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(397)
	
	/* script */
	__vue_exports__ = __webpack_require__(349)
	
	/* template */
	var __vue_template__ = __webpack_require__(402)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-69ee7bf2"
	
	module.exports = __vue_exports__


/***/ }),

/***/ 402:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    attrs: {
	      "id": "captcha-button"
	    }
	  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "captcha-element"
	    }
	  })])
	},staticRenderFns: []}

/***/ }),

/***/ 593:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _Header = __webpack_require__(313);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _elementUi = __webpack_require__(198);
	
	var _elementUi2 = _interopRequireDefault(_elementUi);
	
	__webpack_require__(161);
	
	var _http = __webpack_require__(4);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _GlobalConfig = __webpack_require__(2);
	
	var _GlobalConfig2 = _interopRequireDefault(_GlobalConfig);
	
	var _layer = __webpack_require__(5);
	
	var _layer2 = _interopRequireDefault(_layer);
	
	__webpack_require__(179);
	
	var _aliCaptcha = __webpack_require__(401);
	
	var _aliCaptcha2 = _interopRequireDefault(_aliCaptcha);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_elementUi2.default);
	
	exports.default = {
	  components: { OpHeader: _Header2.default, aliCaptcha: _aliCaptcha2.default },
	  name: "app",
	  data: function data() {
	    var _this2 = this;
	
	    var checkMobile = function checkMobile(rule, value, callback) {
	      var patt = new RegExp("^1[1-9]\\d{9}$");
	      if (!patt.test(value)) {
	        callback(new Error('不是合法的手机号'));
	      }
	      var url = _GlobalConfig2.default.domain.accountWeb + "/user/verificationMobilePhone";
	      _http2.default.post(url, { mobilePhoneNo: value }, function (response) {
	        var result = response.data;
	        if (!result) {
	          callback(new Error("该手机号已存在"));
	        } else {
	          callback();
	        }
	      });
	    };
	    var checkEmail = function checkEmail(rule, value, callback) {
	      var patt = new RegExp("^[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$");
	      if (!patt.test(value)) {
	        callback(new Error('不是合法的邮箱账号'));
	      }
	      var url = _GlobalConfig2.default.domain.accountWeb + "/user/verificationEmail";
	      _http2.default.post(url, { email: value }, function (response) {
	        var result = response.data;
	        if (!result) {
	          callback(new Error("该邮箱地址已存在"));
	        } else {
	          callback();
	        }
	      });
	    };
	    var checkPass = function checkPass(rule, value, callback) {
	      var patt = new RegExp("^(?!\\d{6,16}$)[\\S]{6,16}$");
	      if (!patt.test(value)) {
	        callback(new Error('密码必须是6-16位字母、数字组合'));
	      }
	      callback();
	    };
	    var checkAuthCode = function checkAuthCode(rule, value, callback) {
	      var _this = _this2;
	      var url = _GlobalConfig2.default.domain.accountWeb + "/validateCode/validateAuthCode/mobileRegister";
	      _http2.default.post(url, { mobileOrEmail: _this.personInfo.mobile, authCode: value }, function (response) {
	        var result = response.data;
	        if (result) {
	          callback();
	        } else {
	          callback(new Error("验证码错误"));
	        }
	      });
	    };
	    var checkRandomCode = function checkRandomCode(rule, value, callback) {
	      var url;
	      if (_this2.registerType == 'person') {
	        url = _GlobalConfig2.default.domain.accountWeb + "/validateCode/validateRandomCode/mobileRegister";
	      }
	      if (_this2.registerType == 'enterprise') {
	        url = _GlobalConfig2.default.domain.accountWeb + "/validateCode/validateRandomCode/emailRegister";
	      }
	      _http2.default.post(url, { randomCode: value }, function (response) {
	        var result = response.data;
	        if (result) {
	          callback();
	        } else {
	          callback(new Error('图形验证码错误'));
	        }
	      });
	    };
	    return {
	      downText: '发送验证码',
	      downdis: false,
	      registerType: 'person',
	      personInfo: {
	        mobile: '',
	        password: '',
	        randomCode: '',
	        authCode: ''
	      },
	      enterpriseInfo: {
	        companyName: '',
	        email: '',
	        ePassword: '',
	        eRandomCode: '',
	        linkMobile: ''
	      },
	      agreement: false,
	      btnTimer: null,
	      currentBtn: null,
	      pImgCodeSrc: _GlobalConfig2.default.domain.accountWeb + "/validateCode/createRandomCode/mobileRegister",
	      eImgCodeSrc: _GlobalConfig2.default.domain.accountWeb + "/validateCode/createRandomCode/emailRegister",
	      personRules: {
	        mobile: [{ required: true, message: '请输入电话号码', trigger: 'blur' }, { validator: checkMobile, trigger: 'blur' }],
	        password: [{ required: true, message: '请输入密码', trigger: 'blur' }, { validator: checkPass, trigger: 'blur' }],
	        randomCode: [{ required: true, message: '请输入图形验证码', trigger: 'blur' }, { validator: checkRandomCode, trigger: 'blur' }],
	        authCode: [{ required: true, message: '请输入短信验证码', trigger: 'blur' }, { validator: checkAuthCode, trigger: 'blur' }]
	      },
	      enterpriseRules: {
	        companyName: [{ required: true, message: '请输入企业名称', trigger: 'blur' }],
	        email: [{ required: true, message: '请输入邮箱地址', trigger: 'blur' }, { validator: checkEmail, trigger: 'blur' }],
	        linkMobile: [{ required: true, message: '联系方式不能为空', trigger: 'blur' }],
	        ePassword: [{ required: true, message: '请输入密码', trigger: 'blur' }, { validator: checkPass, trigger: 'blur' }],
	        eRandomCode: [{ required: true, message: '请输入图形验证码', trigger: 'blur' }, { validator: checkRandomCode, trigger: 'blur' }]
	      },
	      spreadInviteCode: null
	    };
	  },
	  created: function created() {
	    this.registerType = this.$ebqUtil.parseUrlParam(location.href).tag || 'person';
	    this.spreadInviteCode = this.$ebqUtil.parseUrlParam(location.href).si;
	  },
	
	  methods: {
	    switchRegisterType: function switchRegisterType(value) {
	      if (value !== this.registerType) {
	        window.location.href = _GlobalConfig2.default.domain.forensicsWebOp + "/register.html?tag=" + value + (this.spreadInviteCode ? "&si=" + this.spreadInviteCode : "");
	      }
	    },
	    getRandomCode: function getRandomCode() {
	      if (this.registerType == 'person') {
	        this.pImgCodeSrc = _GlobalConfig2.default.domain.accountWeb + "/validateCode/createRandomCode/mobileRegister?" + new Date().getTime();
	      }
	      if (this.registerType == 'enterprise') {
	        this.eImgCodeSrc = _GlobalConfig2.default.domain.accountWeb + "/validateCode/createRandomCode/emailRegister?" + new Date().getTime();
	      }
	    },
	    countdownLe: function countdownLe() {
	      var _this3 = this;
	
	      var time = 120,
	          timer = null;
	      this.downText = "重新发送(" + time + "s)";
	      this.downdis = true;
	      timer = setInterval(function () {
	        if (time > 0) {
	          _this3.downText = "重新发送(" + --time + "s)";
	          _this3.downdis = true;
	        } else {
	          _this3.downdis = false;
	          _this3.downText = "发送验证码";
	          clearInterval(timer);
	        }
	      }, 1000);
	    },
	    newSend: function newSend(callback) {
	      this.$refs['form'].validateField("mobile", function (errMsg) {
	        if (!errMsg) {
	          if (callback) callback();
	        }
	      });
	    },
	
	    sendMobileCode: function sendMobileCode(e) {
	      var _this = this;
	
	      var url = _GlobalConfig2.default.domain.accountWeb + "/validateCode/sendAuthCode/mobileRegister";
	      var data = {};
	      data.randomCode = _this.personInfo.randomCode;
	      data.mobileOrEmail = _this.personInfo.mobile;
	      var flag = false;
	      _this.$refs['form'].validateField("mobile", function (valid) {
	        if (valid == '') {
	          _this.$refs['form'].validateField("randomCode", function (valid) {
	            if (valid == '') {
	              _http2.default.post(url, data, function (response) {
	                var result = response.data;
	                if (result.success) {
	                  _this.sendCountDown();
	                } else {
	                  _layer2.default.msg(result.msg);
	                }
	              });
	            }
	          });
	        }
	      });
	    },
	    enterpriseRegister: function enterpriseRegister() {
	      var _this = this;
	      var url = _GlobalConfig2.default.domain.accountWeb + "/account/register";
	      var data = {};
	      data.userType = 1;
	      data.email = _this.enterpriseInfo.email;
	      data.password = _this.enterpriseInfo.ePassword;
	      data.linkMobile = _this.enterpriseInfo.linkMobile;
	      data.scene = 201;
	      data.companyName = _this.enterpriseInfo.companyName;
	      _this.spreadInviteCode && (data.si = _this.spreadInviteCode);
	      _this.$refs['form'].validate(function (valid) {
	        if (valid) {
	          _http2.default.post(url, data, function (response) {
	            var result = response.data;
	            if (result.success) {
	              _layer2.default.msg("注册成功", { anim: -1 }, function () {
	                window.location.href = _GlobalConfig2.default.domain.forensicsWebOp + "/index.html";
	              });
	            } else {
	              _layer2.default.msg("注册失败，请重新提交资料:" + result.msg);
	            }
	          });
	        }
	      });
	    },
	    personRegister: function personRegister() {
	      var _this = this;
	
	      var url = _GlobalConfig2.default.domain.accountWeb + "/account/register";
	      var data = {};
	      data.userType = 0;
	      data.authCode = _this.personInfo.authCode;
	      data.mobile = _this.personInfo.mobile;
	      data.password = _this.personInfo.password;
	      data.scene = 201;
	      _this.spreadInviteCode && (data.si = _this.spreadInviteCode);
	      _this.$refs['form'].validate(function (valid) {
	        if (valid) {
	          _http2.default.post(url, data, function (response) {
	            var result = response.data;
	            if (result.success) {
	              _layer2.default.msg("注册成功", { anim: -1 }, function () {
	                window.location.href = _GlobalConfig2.default.domain.forensicsWebOp + "/index.html";
	              });
	            } else {
	              _layer2.default.msg("注册失败，请重新提交资料:" + result.msg);
	            }
	          });
	        }
	      });
	    },
	    sendCountDown: function sendCountDown(e, time) {
	      var _this = this;
	      var timer;
	      if (!time) time = 120;
	      timer = setInterval(function () {
	        var btn = $(e);
	        if (time > 0) {
	          this.downText = "重新发送(" + time-- + "s)";
	          this.downdis = true;
	        } else {
	          this.downLoading = false;
	          this.downdis = "发送验证码";
	          _this.getRandomCode();
	          clearInterval(timer);
	        }
	      }, 1000);
	      _this.btnTimer = timer;
	    },
	    showAgreementDiv: function showAgreementDiv() {
	      this.agreement = true;
	      _layer2.default.open({
	        type: 1,
	        area: ['860px', '468px'],
	        title: '电子数据保全服务协议',
	        content: $('#agreementDiv')
	      });
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),

/***/ 956:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1049:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(956)
	
	/* script */
	__vue_exports__ = __webpack_require__(593)
	
	/* template */
	var __vue_template__ = __webpack_require__(1090)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-3f588560"
	
	module.exports = __vue_exports__


/***/ }),

/***/ 1090:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('op-header'), _vm._v(" "), _c('div', {
	    staticClass: "content register22 content-min-height"
	  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('ul', {
	    staticClass: "bar"
	  }, [_c('li', {
	    class: _vm.registerType == 'person' ? 'active' : '',
	    on: {
	      "click": function($event) {
	        return _vm.switchRegisterType('person')
	      }
	    }
	  }, [_vm._v("\n          个人注册\n        ")]), _vm._v(" "), _c('li', {
	    class: _vm.registerType == 'enterprise' ? 'active' : '',
	    on: {
	      "click": function($event) {
	        return _vm.switchRegisterType('enterprise')
	      }
	    }
	  }, [_vm._v("\n          企业注册\n        ")])])]), _vm._v(" "), (_vm.registerType == 'person') ? _c('div', [_c('el-form', {
	    ref: "form",
	    attrs: {
	      "model": _vm.personInfo,
	      "rules": _vm.personRules,
	      "label-width": "100px",
	      "size": "small",
	      "name": "personForm"
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "手机账户",
	      "prop": "mobile"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "placeholder": "请输入您的手机号码",
	      "name": "mobile"
	    },
	    model: {
	      value: (_vm.personInfo.mobile),
	      callback: function($$v) {
	        _vm.$set(_vm.personInfo, "mobile", $$v)
	      },
	      expression: "personInfo.mobile"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "登录密码",
	      "prop": "password"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "type": "password",
	      "placeholder": "由6-14数字、字母组成",
	      "name": "password"
	    },
	    model: {
	      value: (_vm.personInfo.password),
	      callback: function($$v) {
	        _vm.$set(_vm.personInfo, "password", $$v)
	      },
	      expression: "personInfo.password"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "手机验证",
	      "prop": "authCode"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "placeholder": "请输入您的手机验证码",
	      "name": "authCode"
	    },
	    model: {
	      value: (_vm.personInfo.authCode),
	      callback: function($$v) {
	        _vm.$set(_vm.personInfo, "authCode", $$v)
	      },
	      expression: "personInfo.authCode"
	    }
	  }, [_c('aliCaptcha', {
	    attrs: {
	      "slot": "append",
	      "handCallback": _vm.countdownLe,
	      "verify": _vm.newSend,
	      "verifyType": 2,
	      "mobileOrEmail": _vm.personInfo.mobile
	    },
	    slot: "append"
	  }, [_c('el-button', {
	    staticStyle: {
	      "width": "109px",
	      "background-color": "#023D92",
	      "color": "#fff",
	      "padding": "12px 0"
	    },
	    attrs: {
	      "disabled": _vm.downdis
	    }
	  }, [_vm._v(_vm._s(_vm.downText))])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
	    staticStyle: {
	      "text-align": "left"
	    }
	  }, [_c('el-checkbox', {
	    model: {
	      value: (_vm.agreement),
	      callback: function($$v) {
	        _vm.agreement = $$v
	      },
	      expression: "agreement"
	    }
	  }, [_c('span', {
	    staticStyle: {
	      "color": "#000"
	    }
	  }, [_vm._v("我已阅读")]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "javascript:void(0)"
	    },
	    on: {
	      "click": _vm.showAgreementDiv
	    }
	  }, [_vm._v("《电子数据保全服务协议》")])])], 1), _vm._v(" "), _c('el-form-item', [(_vm.agreement) ? _c('el-button', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": _vm.personRegister
	    }
	  }, [_vm._v("同意协议并注册")]) : _c('el-button', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "type": "info",
	      "disabled": ""
	    }
	  }, [_vm._v("同意协议并注册")])], 1)], 1)], 1) : (_vm.registerType == 'enterprise') ? _c('div', [_c('el-form', {
	    ref: "form",
	    attrs: {
	      "model": _vm.enterpriseInfo,
	      "rules": _vm.enterpriseRules,
	      "label-width": "100px",
	      "size": "small",
	      "name": "enterpriseForm"
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "企业名称",
	      "prop": "companyName"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "placeholder": "请输入企业名称",
	      "name": "companyName"
	    },
	    model: {
	      value: (_vm.enterpriseInfo.companyName),
	      callback: function($$v) {
	        _vm.$set(_vm.enterpriseInfo, "companyName", $$v)
	      },
	      expression: "enterpriseInfo.companyName"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "邮箱账号",
	      "prop": "email"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "placeholder": "请输入您的邮箱",
	      "name": "email"
	    },
	    model: {
	      value: (_vm.enterpriseInfo.email),
	      callback: function($$v) {
	        _vm.$set(_vm.enterpriseInfo, "email", $$v)
	      },
	      expression: "enterpriseInfo.email"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    staticClass: "is-required",
	    attrs: {
	      "label": "联系方式",
	      "prop": "linkMobile"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "placeholder": "请输入您的联系方式",
	      "name": "linkMobile"
	    },
	    model: {
	      value: (_vm.enterpriseInfo.linkMobile),
	      callback: function($$v) {
	        _vm.$set(_vm.enterpriseInfo, "linkMobile", $$v)
	      },
	      expression: "enterpriseInfo.linkMobile"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "登录密码",
	      "prop": "ePassword"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "type": "password",
	      "placeholder": "由6-14数字、字母组成",
	      "name": "password"
	    },
	    model: {
	      value: (_vm.enterpriseInfo.ePassword),
	      callback: function($$v) {
	        _vm.$set(_vm.enterpriseInfo, "ePassword", $$v)
	      },
	      expression: "enterpriseInfo.ePassword"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "图形验证",
	      "prop": "eRandomCode"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "type": "text",
	      "placeholder": "请输入图形验证码",
	      "name": "eRandomCode"
	    },
	    model: {
	      value: (_vm.enterpriseInfo.eRandomCode),
	      callback: function($$v) {
	        _vm.$set(_vm.enterpriseInfo, "eRandomCode", $$v)
	      },
	      expression: "enterpriseInfo.eRandomCode"
	    }
	  }, [_c('template', {
	    slot: "append"
	  }, [_c('img', {
	    staticStyle: {
	      "height": "30px"
	    },
	    attrs: {
	      "src": _vm.eImgCodeSrc
	    },
	    on: {
	      "click": _vm.getRandomCode
	    }
	  })])], 2)], 1), _vm._v(" "), _c('el-form-item', {
	    staticStyle: {
	      "text-align": "left"
	    }
	  }, [_c('el-checkbox', {
	    model: {
	      value: (_vm.agreement),
	      callback: function($$v) {
	        _vm.agreement = $$v
	      },
	      expression: "agreement"
	    }
	  }, [_c('span', {
	    staticStyle: {
	      "color": "#000"
	    }
	  }, [_vm._v("我已阅读")]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "javascript:void(0)"
	    },
	    on: {
	      "click": _vm.showAgreementDiv
	    }
	  }, [_vm._v("《电子数据保全服务协议》")])])], 1), _vm._v(" "), _c('el-form-item', [(_vm.agreement) ? _c('el-button', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": _vm.enterpriseRegister
	    }
	  }, [_vm._v("同意协议并注册")]) : _c('el-button', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "type": "info",
	      "disabled": ""
	    }
	  }, [_vm._v("同意协议并注册")])], 1)], 1)], 1) : _vm._e()]), _vm._v(" "), _vm._m(1)], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "logo"
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/img/logo_black.png"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "display": "none",
	      "width": "800px",
	      "margin": "0 auto",
	      "padding": "30px 60px",
	      "font": "12px 'Microsoft YaHei', Arial",
	      "line-height": "24px",
	      "color": "#5B5B5B"
	    },
	    attrs: {
	      "id": "agreementDiv"
	    }
	  }, [_c('p', [_vm._v("\n      本协议是您（以下也称\"服务使用人\"）与易保全（电子数据保全中心）平台之间关于电子数据保全各项服务的协议。本协议内容包括协议正文、易保全（电子数据保全中心）当前以及今后随时发布的关于电子数据保全服务的各种规范、规则等。本协议中的\"保全中心平台\"是指由易保全网络科技有限公司提供的电子数据保全综合服务平台，域名为www.ebaoquan.org。\n      我们在此特别提醒，在使用保全中心平台上提供的各项服务前，请您务必事先认真阅读本协议所有内容，协议中包含了保全中心平台的免责条款以及对用户的权利限制条款。请您审阅并对是否接受所有服务条款作出明确意思表示，若您承诺接受本协议则须遵守本协议相关条款；若您不接受则应立即停止注册程序或停止使用易保全（电子数据保全中心）的相关服务。若您有不明白之处，请务必向保全中心工作人员垂询，中心工作人员将向您作详细的说明和解释。\n      易保全（电子数据保全中心）有权根据需要制订、修改本协议及各种规范、规则等，并在其平台上进行公告。变更后的协议和规范、规则一经公告，立即生效，您可以随时登陆保全中心平台查阅相关信息。如果您不同意相关变更，应当立即停止使用电子数据保全的相关服务。如您继续使用电子数据保全的相关服务，即视为您接受经修订的协议和规范、规则。\n    ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', {
	    staticStyle: {
	      "margin-bottom": "10px",
	      "font-family": "'Microsoft YaHei'"
	    }
	  }, [_vm._v("一、产品保护条款")]), _vm._v(" "), _c('p', [_vm._v("\n      1、易保全（电子数据保全中心）所提供的服务涉及的文字表述及组合、图片、网页设计等，以及各软件、技术均属电子数据保全中心所有，受《中华人民共和国著作权法》和其他知识产权法等相关法律法规的保护。易保全（电子数据保全中心）保留追究任何第三方侵权使用本网站成果的权力。\n      2、您应正当使用电子数据保全中心的各项服务并承担一定的意外风险。在使用保全服务过程中，您不得从事任何影响网络正常运作的行为，包括借助装置、软件或例行程序进行干预等易保全（电子数据保全中心）在任何情况下不对因服务使用人不正当使用、有意或恶意利用服务的缺陷或其他特殊的、意外的原因（或行为）造成的非直接或间接的损失承担赔偿责任。\n      3、由于易保全（电子数据保全中心）的各项服务涉及到互联网服务、本地操作环境、网络各环节等因素的影响，因此服务可能因计算机病毒或黑客攻击、网络提供商提供的服务差异化或出现意外状况、用户所在位置以及其他任何技术、互联网络、通信线路等原因出现异常或其他不能满足用户要求的风险。对非保全中心平台造成的以上风险，易保全（电子数据保全中心）不承担任何责任。\n    ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', {
	    staticStyle: {
	      "margin-bottom": "10px",
	      "font-family": "'Microsoft YaHei'"
	    }
	  }, [_vm._v("二、新用户注册")]), _vm._v(" "), _c('p', [_vm._v("\n      1、（1）在您进行易保全（电子数据保全中心）注册或实际使用保全中心平台提供的服务时，您应具备完全民事权利能力和完全民事行为。若您不具备前述主体资格，易保全（电子数据保全中心）保留对您的账号采取冻结使用乃至注销您的账户等权利。\n      （2）涉及无民事行为能力人、限制民事行为能力人的保全服务，建议以其监护人的名义申请保全中心平台并获取保全中心提供的服务。\n      2、在您注册时应填写真实有效的身份信息，注册时请务必使用您本人的真实信息，并确保注册时所需信息填写准确、完全。虚假身份信息会导致无法进行身份认证。身份认证是相关司法机构为您出具司法文书的前提。建议您在注册后尽快进行基本或者高级身份认证，方便保全中心出具保全证书以及日后申请出具相关司法文书，同时也可获得平台其他更多服务。\n      3、请您务必认真阅读本协议，在完全接受本协议条款后，方可注册成保全中心平台的用户。一旦注册成为我们的用户，即表示您同意接受协议各项条款的约束，包括接受保全中心平台今后随时对服务条款所做的任何修改。届时您不应以未阅读本协议或不理解本协议的内容为由，主张协议无效或要求撤销协议。\n      4、在你注册为保全中心平台用户后，应牢记您的用户名及登录密码，妥善保管登录密码，采取积极的保密措施保护您（注册人）的上述信息及资料免受窃取。用户名及登录密码将作为保全中心平台确认您的身份的依据，您应对您的用户名和密码的安全，以及通过您的用户名和密码实施的行为负责。因用户自己遗失本保全中心平台账号密码或自行将保全文件发布到其他网络平台而造成保全文件内容泄露的，由用户自行承担责任，易保全（电子数据保全中心）对此不承担任何责任。\n      5、保全中心平台会对已上传的作品加强技术保护。所有上传的作品经三层加密，保存在自建的云存储环境，以确保每位上传作品用户原始信息的安全。易保全（电子数据保全中心）非经您本人（服务使用人）许可，不会将您的信息及保全内容泄露给他人。\n    ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', {
	    staticStyle: {
	      "margin-bottom": "10px",
	      "font-family": "'Microsoft YaHei'"
	    }
	  }, [_vm._v("三、保全中心平台服务使用规范")]), _vm._v(" "), _c('p', [_vm._v("\n      1、（1）您必须合法地使用保全中心平台的各项服务，在使用保全中心平台上的各项服务时，您应当对通过您的账号所实施的一切行为负责。\n      （2）您不得利用保全中心平台的各项服务及产品从事非法活动，包括且不限于利用本站传播、存取非法、违反公序良俗的内容，不可采用网络、电脑技术等各种手段，制造虚假证据，并利用易保全（电子数据保全中心）服务以获取个人利益。\n      （3）您不得上传违反中华人民共和国相关法律法规的规定的文件至保全中心平台。禁止上传的材料类型包括：（1）包含侵犯他人著作权、商标权、专利权、名誉权、隐私权、物权、商业秘密等合法权益内容信息的材料。（2）含有危害国家安全、损害国家荣誉和利益、损害社会公共利益、泄露国家机密、违反国家民族宗教法律政策、破坏社会公共秩序、淫秽色情、暴力、赌博、恐怖主义；教唆犯罪；侮辱诽谤他人；侵犯他人个人隐私等内容信息的材料。（3）含有政治因素作品或者国家规定的其他需获得行政许可的作品。（4）其他违反法律法规、有损社会公序良俗的材料。\n      （4）电子数据保全中心是为用户提供保全文件保护的第三方服务商。保全中心平台内容的真实性由您本人负责，涉及到您单方意思表示的，请慎重考虑后作出。电子数据保全中心不做审查、判断保全文件是否侵权的承诺，也不对用户所发布信息的合法性、真实性及其品质等进行审查。若发现平台上有违法侵权（具体违反前述第（3）条）的保全文件，欢迎举报。保全中心会及时对该文件做出下线处理。\n      （5）经发现或接到举报，或有合理理由怀疑您的账号存在违法情况及其他违反本协议的行为时，保全中心平台有权对你的账号采取限制措施，并限期要求您向保全中心平台公开可疑内容，限期进行整改，直至删除您的资料或应公安机关、司法机关的要求公开（公示）您的信息及违法内容、注销您的账号。保全中心平台有权对您是否存在上述违法情况、违反本协议的行为单方作出认定，采取上述各项措施，无须征得您的同意或提前通知予您。\n      2、（1）对于您的行为（包括非法的或正常使用保全中心服务的行为）对任意第三方造成损害的，您均应以自己的名义独立承担所有的法律责任，并应确保免于对保全中心造成损失。\n      （2）如保全中心平台因您的行为（包括非法的或正常使用保全中心服务服务的行为）遭受任何损失，或受到任何第三方的索赔，或受到任何行政管理部门的处罚，您应当赔偿保全中心平台因此造成的损失及（或）发生的一切费用。\n      3、（1）您如果发现或怀疑您的账号被盗用，或存在其他安全问题时，您应当立即以有效方式通知保全中心平台，并可以要求保全中心平台采取一定的措施，且应配合保全中心平台为采取措施而实施的调查、要求补证、身份核实等工作。若您所提供的资料未能使保全中心平台完全确信您是账号的注册人时，保全中心平台可能不会应您的要求采取措施。\n      （2）保全中心平台不对您账号使用的安全问题承担任何责任。但您若冒用他人名义要求保全中心平台对账号采取措施导致侵权、致他人损失的，您应承担一切责任。\n      4、因您填写、预留的联系方式有误，导致保全中心平台无法与您取得联系的，因此产生的后果由您自行负责，包括您使用服务过程中产生任何损失或增加费用等。\n      5、（1）保全中心平台提供的保全、合同保、日志保等服务均有一定的针对性，保全方式因服务内容不同而不尽相同。在使用前务必认真了解各项服务内容。\n      （2）涉及交叉使用保全中心平台提供的各项服务的，如有不清楚之处，务必联系工作人员，由工作人员对您进行指导。\n      6、在完成保全之后，务必对保全的证书进行浏览、查看、确认，以免在因服务限制、错用服务等各项原因导致保全证书不能及时生成的情况下，及时采取补救措施。\n      7、保全中心平台提供的保全服务均为自助型服务，请勿向客服人员提出参与保全的要求。\n      8、为确保保全服务的网络安全，防止信息泄露，请您不要在公用电脑上进行保全服务。\n    ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', {
	    staticStyle: {
	      "margin-bottom": "10px",
	      "font-family": "'Microsoft YaHei'"
	    }
	  }, [_vm._v("四、用户的终止与注销")]), _vm._v(" "), _c('p', [_vm._v("\n      1、出现以下情况时，保全中心平台有权直接以注销用户的方式终止本协议:\n      （1）您不是具备完全民事权利能力和完全民事行为能力的自然人；\n      （2）您注册信息中的主要内容不真实、不准确、不及时、不完整，或注册信息包含非法的、可能侵犯他人合法权益的、违背社会公序良俗的内容，并经保全中心平台提示后未在限期内进行修改的；\n      （3）一经发现您利用保全中心平台从事违法的、侵犯他人合法权益、违背社会公序良俗的行为，且经保全中心平台提示后未在限期内改正的；\n      （4）本协议（含规则）变更时，您明示并通知保全中心平台不愿接受新的服务协议的；\n      （5）其它保全中心平台认为应当终止服务的情况。\n      2、您与保全中心平台的协议关系终止后，您在使用保全中心服务平台期间存在违法行为或违反本协议或规则的行为的，保全中心仍可依据本协议向您要求承担法律责任。\n    ")])])
	}]}

/***/ })

});


// WEBPACK FOOTER //
// static/js/register.f727e33b470ef51fa9a8.js